function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2018 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof2(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("pdfjs-dist/web/pdf_viewer", [], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object') exports["pdfjs-dist/web/pdf_viewer"] = factory();else root["pdfjs-dist/web/pdf_viewer"] = root.pdfjsViewer = factory();
})(this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __w_pdfjs_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __w_pdfjs_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __w_pdfjs_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __w_pdfjs_require__.d = function (exports, name, getter) {
        /******/
        if (!__w_pdfjs_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __w_pdfjs_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __w_pdfjs_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __w_pdfjs_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && _typeof2(value) === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __w_pdfjs_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __w_pdfjs_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __w_pdfjs_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __w_pdfjs_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __w_pdfjs_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __w_pdfjs_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __w_pdfjs_require__(__w_pdfjs_require__.s = 0);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      Object.defineProperty(exports, "AnnotationLayerBuilder", {
        enumerable: true,
        get: function get() {
          return _annotation_layer_builder.AnnotationLayerBuilder;
        }
      });
      Object.defineProperty(exports, "DefaultAnnotationLayerFactory", {
        enumerable: true,
        get: function get() {
          return _annotation_layer_builder.DefaultAnnotationLayerFactory;
        }
      });
      Object.defineProperty(exports, "DefaultTextLayerFactory", {
        enumerable: true,
        get: function get() {
          return _text_layer_builder.DefaultTextLayerFactory;
        }
      });
      Object.defineProperty(exports, "TextLayerBuilder", {
        enumerable: true,
        get: function get() {
          return _text_layer_builder.TextLayerBuilder;
        }
      });
      Object.defineProperty(exports, "EventBus", {
        enumerable: true,
        get: function get() {
          return _ui_utils.EventBus;
        }
      });
      Object.defineProperty(exports, "NullL10n", {
        enumerable: true,
        get: function get() {
          return _ui_utils.NullL10n;
        }
      });
      Object.defineProperty(exports, "ProgressBar", {
        enumerable: true,
        get: function get() {
          return _ui_utils.ProgressBar;
        }
      });
      Object.defineProperty(exports, "PDFLinkService", {
        enumerable: true,
        get: function get() {
          return _pdf_link_service.PDFLinkService;
        }
      });
      Object.defineProperty(exports, "SimpleLinkService", {
        enumerable: true,
        get: function get() {
          return _pdf_link_service.SimpleLinkService;
        }
      });
      Object.defineProperty(exports, "DownloadManager", {
        enumerable: true,
        get: function get() {
          return _download_manager.DownloadManager;
        }
      });
      Object.defineProperty(exports, "GenericL10n", {
        enumerable: true,
        get: function get() {
          return _genericl10n.GenericL10n;
        }
      });
      Object.defineProperty(exports, "PDFFindController", {
        enumerable: true,
        get: function get() {
          return _pdf_find_controller.PDFFindController;
        }
      });
      Object.defineProperty(exports, "PDFHistory", {
        enumerable: true,
        get: function get() {
          return _pdf_history.PDFHistory;
        }
      });
      Object.defineProperty(exports, "PDFPageView", {
        enumerable: true,
        get: function get() {
          return _pdf_page_view.PDFPageView;
        }
      });
      Object.defineProperty(exports, "PDFSinglePageViewer", {
        enumerable: true,
        get: function get() {
          return _pdf_single_page_viewer.PDFSinglePageViewer;
        }
      });
      Object.defineProperty(exports, "PDFViewer", {
        enumerable: true,
        get: function get() {
          return _pdf_viewer.PDFViewer;
        }
      });

      var _annotation_layer_builder = __w_pdfjs_require__(1);

      var _text_layer_builder = __w_pdfjs_require__(9);

      var _ui_utils = __w_pdfjs_require__(3);

      var _pdf_link_service = __w_pdfjs_require__(8);

      var _download_manager = __w_pdfjs_require__(10);

      var _genericl10n = __w_pdfjs_require__(11);

      var _pdf_find_controller = __w_pdfjs_require__(13);

      var _pdf_history = __w_pdfjs_require__(15);

      var _pdf_page_view = __w_pdfjs_require__(16);

      var _pdf_single_page_viewer = __w_pdfjs_require__(19);

      var _pdf_viewer = __w_pdfjs_require__(21);

      var pdfjsVersion = '2.1.266';
      var pdfjsBuild = '81f5835c';
      (0, _ui_utils.getGlobalEventBus)(true);
      /***/
    },
    /* 1 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.DefaultAnnotationLayerFactory = exports.AnnotationLayerBuilder = void 0;

      var _pdfjsLib = __w_pdfjs_require__(2);

      var _ui_utils = __w_pdfjs_require__(3);

      var _pdf_link_service = __w_pdfjs_require__(8);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var AnnotationLayerBuilder =
      /*#__PURE__*/
      function () {
        function AnnotationLayerBuilder(_ref) {
          var pageDiv = _ref.pageDiv,
              pdfPage = _ref.pdfPage,
              linkService = _ref.linkService,
              downloadManager = _ref.downloadManager,
              _ref$imageResourcesPa = _ref.imageResourcesPath,
              imageResourcesPath = _ref$imageResourcesPa === void 0 ? '' : _ref$imageResourcesPa,
              _ref$renderInteractiv = _ref.renderInteractiveForms,
              renderInteractiveForms = _ref$renderInteractiv === void 0 ? false : _ref$renderInteractiv,
              _ref$l10n = _ref.l10n,
              l10n = _ref$l10n === void 0 ? _ui_utils.NullL10n : _ref$l10n;

          _classCallCheck(this, AnnotationLayerBuilder);

          this.pageDiv = pageDiv;
          this.pdfPage = pdfPage;
          this.linkService = linkService;
          this.downloadManager = downloadManager;
          this.imageResourcesPath = imageResourcesPath;
          this.renderInteractiveForms = renderInteractiveForms;
          this.l10n = l10n;
          this.div = null;
          this._cancelled = false;
        }

        _createClass(AnnotationLayerBuilder, [{
          key: "render",
          value: function render(viewport) {
            var _this = this;

            var intent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'display';
            this.pdfPage.getAnnotations({
              intent: intent
            }).then(function (annotations) {
              if (_this._cancelled) {
                return;
              }

              var parameters = {
                viewport: viewport.clone({
                  dontFlip: true
                }),
                div: _this.div,
                annotations: annotations,
                page: _this.pdfPage,
                imageResourcesPath: _this.imageResourcesPath,
                renderInteractiveForms: _this.renderInteractiveForms,
                linkService: _this.linkService,
                downloadManager: _this.downloadManager
              };

              if (_this.div) {
                _pdfjsLib.AnnotationLayer.update(parameters);
              } else {
                if (annotations.length === 0) {
                  return;
                }

                _this.div = document.createElement('div');
                _this.div.className = 'annotationLayer';

                _this.pageDiv.appendChild(_this.div);

                parameters.div = _this.div;

                _pdfjsLib.AnnotationLayer.render(parameters);

                _this.l10n.translate(_this.div);
              }
            });
          }
        }, {
          key: "cancel",
          value: function cancel() {
            this._cancelled = true;
          }
        }, {
          key: "hide",
          value: function hide() {
            if (!this.div) {
              return;
            }

            this.div.setAttribute('hidden', 'true');
          }
        }]);

        return AnnotationLayerBuilder;
      }();

      exports.AnnotationLayerBuilder = AnnotationLayerBuilder;

      var DefaultAnnotationLayerFactory =
      /*#__PURE__*/
      function () {
        function DefaultAnnotationLayerFactory() {
          _classCallCheck(this, DefaultAnnotationLayerFactory);
        }

        _createClass(DefaultAnnotationLayerFactory, [{
          key: "createAnnotationLayerBuilder",
          value: function createAnnotationLayerBuilder(pageDiv, pdfPage) {
            var imageResourcesPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var renderInteractiveForms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var l10n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _ui_utils.NullL10n;
            return new AnnotationLayerBuilder({
              pageDiv: pageDiv,
              pdfPage: pdfPage,
              imageResourcesPath: imageResourcesPath,
              renderInteractiveForms: renderInteractiveForms,
              linkService: new _pdf_link_service.SimpleLinkService(),
              l10n: l10n
            });
          }
        }]);

        return DefaultAnnotationLayerFactory;
      }();

      exports.DefaultAnnotationLayerFactory = DefaultAnnotationLayerFactory;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      var pdfjsLib;

      if (typeof window !== 'undefined' && window['pdfjs-dist/build/pdf']) {
        pdfjsLib = window['pdfjs-dist/build/pdf'];
      } else {
        pdfjsLib = require("../build/pdf.js");
      }

      module.exports = pdfjsLib;
      /***/
    },
    /* 3 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.isValidRotation = isValidRotation;
      exports.isValidScrollMode = isValidScrollMode;
      exports.isValidSpreadMode = isValidSpreadMode;
      exports.isPortraitOrientation = isPortraitOrientation;
      exports.getGlobalEventBus = getGlobalEventBus;
      exports.getPDFFileNameFromURL = getPDFFileNameFromURL;
      exports.noContextMenuHandler = noContextMenuHandler;
      exports.parseQueryString = parseQueryString;
      exports.backtrackBeforeAllVisibleElements = backtrackBeforeAllVisibleElements;
      exports.getVisibleElements = getVisibleElements;
      exports.roundToDivide = roundToDivide;
      exports.getPageSizeInches = getPageSizeInches;
      exports.approximateFraction = approximateFraction;
      exports.getOutputScale = getOutputScale;
      exports.scrollIntoView = scrollIntoView;
      exports.watchScroll = watchScroll;
      exports.binarySearchFirstItem = binarySearchFirstItem;
      exports.normalizeWheelEventDelta = normalizeWheelEventDelta;
      exports.waitOnEventOrTimeout = waitOnEventOrTimeout;
      exports.moveToEndOfArray = moveToEndOfArray;
      exports.WaitOnType = exports.animationStarted = exports.ProgressBar = exports.EventBus = exports.NullL10n = exports.SpreadMode = exports.ScrollMode = exports.TextLayerMode = exports.RendererType = exports.PresentationModeState = exports.VERTICAL_PADDING = exports.SCROLLBAR_PADDING = exports.MAX_AUTO_SCALE = exports.UNKNOWN_SCALE = exports.MAX_SCALE = exports.MIN_SCALE = exports.DEFAULT_SCALE = exports.DEFAULT_SCALE_VALUE = exports.CSS_UNITS = void 0;

      var _regenerator = _interopRequireDefault(__w_pdfjs_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }

        return _typeof(obj);
      }

      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
      }

      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }

      function _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);

            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }

      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }

      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }

      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
              args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
          });
        };
      }

      var CSS_UNITS = 96.0 / 72.0;
      exports.CSS_UNITS = CSS_UNITS;
      var DEFAULT_SCALE_VALUE = 'auto';
      exports.DEFAULT_SCALE_VALUE = DEFAULT_SCALE_VALUE;
      var DEFAULT_SCALE = 1.0;
      exports.DEFAULT_SCALE = DEFAULT_SCALE;
      var MIN_SCALE = 0.10;
      exports.MIN_SCALE = MIN_SCALE;
      var MAX_SCALE = 10.0;
      exports.MAX_SCALE = MAX_SCALE;
      var UNKNOWN_SCALE = 0;
      exports.UNKNOWN_SCALE = UNKNOWN_SCALE;
      var MAX_AUTO_SCALE = 1.25;
      exports.MAX_AUTO_SCALE = MAX_AUTO_SCALE;
      var SCROLLBAR_PADDING = 40;
      exports.SCROLLBAR_PADDING = SCROLLBAR_PADDING;
      var VERTICAL_PADDING = 5;
      exports.VERTICAL_PADDING = VERTICAL_PADDING;
      var PresentationModeState = {
        UNKNOWN: 0,
        NORMAL: 1,
        CHANGING: 2,
        FULLSCREEN: 3
      };
      exports.PresentationModeState = PresentationModeState;
      var RendererType = {
        CANVAS: 'canvas',
        SVG: 'svg'
      };
      exports.RendererType = RendererType;
      var TextLayerMode = {
        DISABLE: 0,
        ENABLE: 1,
        ENABLE_ENHANCE: 2
      };
      exports.TextLayerMode = TextLayerMode;
      var ScrollMode = {
        UNKNOWN: -1,
        VERTICAL: 0,
        HORIZONTAL: 1,
        WRAPPED: 2
      };
      exports.ScrollMode = ScrollMode;
      var SpreadMode = {
        UNKNOWN: -1,
        NONE: 0,
        ODD: 1,
        EVEN: 2
      };
      exports.SpreadMode = SpreadMode;

      function formatL10nValue(text, args) {
        if (!args) {
          return text;
        }

        return text.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) {
          return name in args ? args[name] : '{{' + name + '}}';
        });
      }

      var NullL10n = {
        getLanguage: function () {
          var _getLanguage = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator["default"].mark(function _callee() {
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", 'en-us');

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function getLanguage() {
            return _getLanguage.apply(this, arguments);
          }

          return getLanguage;
        }(),
        getDirection: function () {
          var _getDirection = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator["default"].mark(function _callee2() {
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", 'ltr');

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function getDirection() {
            return _getDirection.apply(this, arguments);
          }

          return getDirection;
        }(),
        get: function () {
          var _get = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator["default"].mark(function _callee3(property, args, fallback) {
            return _regenerator["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", formatL10nValue(fallback, args));

                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));

          function get(_x, _x2, _x3) {
            return _get.apply(this, arguments);
          }

          return get;
        }(),
        translate: function () {
          var _translate = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator["default"].mark(function _callee4(element) {
            return _regenerator["default"].wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          function translate(_x4) {
            return _translate.apply(this, arguments);
          }

          return translate;
        }()
      };
      exports.NullL10n = NullL10n;

      function getOutputScale(ctx) {
        var devicePixelRatio = window.devicePixelRatio || 1;
        var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
        var pixelRatio = devicePixelRatio / backingStoreRatio;
        return {
          sx: pixelRatio,
          sy: pixelRatio,
          scaled: pixelRatio !== 1
        };
      }

      function scrollIntoView(element, spot) {
        var skipOverflowHiddenElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var parent = element.offsetParent;

        if (!parent) {
          console.error('offsetParent is not set -- cannot scroll');
          return;
        }

        var offsetY = element.offsetTop + element.clientTop;
        var offsetX = element.offsetLeft + element.clientLeft;

        while (parent.clientHeight === parent.scrollHeight && parent.clientWidth === parent.scrollWidth || skipOverflowHiddenElements && getComputedStyle(parent).overflow === 'hidden') {
          if (parent.dataset._scaleY) {
            offsetY /= parent.dataset._scaleY;
            offsetX /= parent.dataset._scaleX;
          }

          offsetY += parent.offsetTop;
          offsetX += parent.offsetLeft;
          parent = parent.offsetParent;

          if (!parent) {
            return;
          }
        }

        if (spot) {
          if (spot.top !== undefined) {
            offsetY += spot.top;
          }

          if (spot.left !== undefined) {
            offsetX += spot.left;
            parent.scrollLeft = offsetX;
          }
        }

        parent.scrollTop = offsetY;
      }

      function watchScroll(viewAreaElement, callback) {
        var debounceScroll = function debounceScroll(evt) {
          if (rAF) {
            return;
          }

          rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
            rAF = null;
            var currentX = viewAreaElement.scrollLeft;
            var lastX = state.lastX;

            if (currentX !== lastX) {
              state.right = currentX > lastX;
            }

            state.lastX = currentX;
            var currentY = viewAreaElement.scrollTop;
            var lastY = state.lastY;

            if (currentY !== lastY) {
              state.down = currentY > lastY;
            }

            state.lastY = currentY;
            callback(state);
          });
        };

        var state = {
          right: true,
          down: true,
          lastX: viewAreaElement.scrollLeft,
          lastY: viewAreaElement.scrollTop,
          _eventHandler: debounceScroll
        };
        var rAF = null;
        viewAreaElement.addEventListener('scroll', debounceScroll, true);
        return state;
      }

      function parseQueryString(query) {
        var parts = query.split('&');
        var params = Object.create(null);

        for (var i = 0, ii = parts.length; i < ii; ++i) {
          var param = parts[i].split('=');
          var key = param[0].toLowerCase();
          var value = param.length > 1 ? param[1] : null;
          params[decodeURIComponent(key)] = decodeURIComponent(value);
        }

        return params;
      }

      function binarySearchFirstItem(items, condition) {
        var minIndex = 0;
        var maxIndex = items.length - 1;

        if (items.length === 0 || !condition(items[maxIndex])) {
          return items.length;
        }

        if (condition(items[minIndex])) {
          return minIndex;
        }

        while (minIndex < maxIndex) {
          var currentIndex = minIndex + maxIndex >> 1;
          var currentItem = items[currentIndex];

          if (condition(currentItem)) {
            maxIndex = currentIndex;
          } else {
            minIndex = currentIndex + 1;
          }
        }

        return minIndex;
      }

      function approximateFraction(x) {
        if (Math.floor(x) === x) {
          return [x, 1];
        }

        var xinv = 1 / x;
        var limit = 8;

        if (xinv > limit) {
          return [1, limit];
        } else if (Math.floor(xinv) === xinv) {
          return [1, xinv];
        }

        var x_ = x > 1 ? xinv : x;
        var a = 0,
            b = 1,
            c = 1,
            d = 1;

        while (true) {
          var p = a + c,
              q = b + d;

          if (q > limit) {
            break;
          }

          if (x_ <= p / q) {
            c = p;
            d = q;
          } else {
            a = p;
            b = q;
          }
        }

        var result;

        if (x_ - a / b < c / d - x_) {
          result = x_ === x ? [a, b] : [b, a];
        } else {
          result = x_ === x ? [c, d] : [d, c];
        }

        return result;
      }

      function roundToDivide(x, div) {
        var r = x % div;
        return r === 0 ? x : Math.round(x - r + div);
      }

      function getPageSizeInches(_ref) {
        var view = _ref.view,
            userUnit = _ref.userUnit,
            rotate = _ref.rotate;

        var _view = _slicedToArray(view, 4),
            x1 = _view[0],
            y1 = _view[1],
            x2 = _view[2],
            y2 = _view[3];

        var changeOrientation = rotate % 180 !== 0;
        var width = (x2 - x1) / 72 * userUnit;
        var height = (y2 - y1) / 72 * userUnit;
        return {
          width: changeOrientation ? height : width,
          height: changeOrientation ? width : height
        };
      }

      function backtrackBeforeAllVisibleElements(index, views, top) {
        if (index < 2) {
          return index;
        }

        var elt = views[index].div;
        var pageTop = elt.offsetTop + elt.clientTop;

        if (pageTop >= top) {
          elt = views[index - 1].div;
          pageTop = elt.offsetTop + elt.clientTop;
        }

        for (var i = index - 2; i >= 0; --i) {
          elt = views[i].div;

          if (elt.offsetTop + elt.clientTop + elt.clientHeight <= pageTop) {
            break;
          }

          index = i;
        }

        return index;
      }

      function getVisibleElements(scrollEl, views) {
        var sortByVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var horizontal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var top = scrollEl.scrollTop,
            bottom = top + scrollEl.clientHeight;
        var left = scrollEl.scrollLeft,
            right = left + scrollEl.clientWidth;

        function isElementBottomAfterViewTop(view) {
          var element = view.div;
          var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
          return elementBottom > top;
        }

        function isElementRightAfterViewLeft(view) {
          var element = view.div;
          var elementRight = element.offsetLeft + element.clientLeft + element.clientWidth;
          return elementRight > left;
        }

        var visible = [],
            numViews = views.length;
        var firstVisibleElementInd = numViews === 0 ? 0 : binarySearchFirstItem(views, horizontal ? isElementRightAfterViewLeft : isElementBottomAfterViewTop);

        if (firstVisibleElementInd > 0 && firstVisibleElementInd < numViews && !horizontal) {
          firstVisibleElementInd = backtrackBeforeAllVisibleElements(firstVisibleElementInd, views, top);
        }

        var lastEdge = horizontal ? right : -1;

        for (var i = firstVisibleElementInd; i < numViews; i++) {
          var view = views[i],
              element = view.div;
          var currentWidth = element.offsetLeft + element.clientLeft;
          var currentHeight = element.offsetTop + element.clientTop;
          var viewWidth = element.clientWidth,
              viewHeight = element.clientHeight;
          var viewRight = currentWidth + viewWidth;
          var viewBottom = currentHeight + viewHeight;

          if (lastEdge === -1) {
            if (viewBottom >= bottom) {
              lastEdge = viewBottom;
            }
          } else if ((horizontal ? currentWidth : currentHeight) > lastEdge) {
            break;
          }

          if (viewBottom <= top || currentHeight >= bottom || viewRight <= left || currentWidth >= right) {
            continue;
          }

          var hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, viewBottom - bottom);
          var hiddenWidth = Math.max(0, left - currentWidth) + Math.max(0, viewRight - right);
          var percent = (viewHeight - hiddenHeight) * (viewWidth - hiddenWidth) * 100 / viewHeight / viewWidth | 0;
          visible.push({
            id: view.id,
            x: currentWidth,
            y: currentHeight,
            view: view,
            percent: percent
          });
        }

        var first = visible[0],
            last = visible[visible.length - 1];

        if (sortByVisibility) {
          visible.sort(function (a, b) {
            var pc = a.percent - b.percent;

            if (Math.abs(pc) > 0.001) {
              return -pc;
            }

            return a.id - b.id;
          });
        }

        return {
          first: first,
          last: last,
          views: visible
        };
      }

      function noContextMenuHandler(evt) {
        evt.preventDefault();
      }

      function isDataSchema(url) {
        var i = 0,
            ii = url.length;

        while (i < ii && url[i].trim() === '') {
          i++;
        }

        return url.substring(i, i + 5).toLowerCase() === 'data:';
      }

      function getPDFFileNameFromURL(url) {
        var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document.pdf';

        if (typeof url !== 'string') {
          return defaultFilename;
        }

        if (isDataSchema(url)) {
          console.warn('getPDFFileNameFromURL: ' + 'ignoring "data:" URL for performance reasons.');
          return defaultFilename;
        }

        var reURI = /^(?:(?:[^:]+:)?\/\/[^\/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
        var reFilename = /[^\/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
        var splitURI = reURI.exec(url);
        var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);

        if (suggestedFilename) {
          suggestedFilename = suggestedFilename[0];

          if (suggestedFilename.includes('%')) {
            try {
              suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
            } catch (ex) {}
          }
        }

        return suggestedFilename || defaultFilename;
      }

      function normalizeWheelEventDelta(evt) {
        var delta = Math.sqrt(evt.deltaX * evt.deltaX + evt.deltaY * evt.deltaY);
        var angle = Math.atan2(evt.deltaY, evt.deltaX);

        if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
          delta = -delta;
        }

        var MOUSE_DOM_DELTA_PIXEL_MODE = 0;
        var MOUSE_DOM_DELTA_LINE_MODE = 1;
        var MOUSE_PIXELS_PER_LINE = 30;
        var MOUSE_LINES_PER_PAGE = 30;

        if (evt.deltaMode === MOUSE_DOM_DELTA_PIXEL_MODE) {
          delta /= MOUSE_PIXELS_PER_LINE * MOUSE_LINES_PER_PAGE;
        } else if (evt.deltaMode === MOUSE_DOM_DELTA_LINE_MODE) {
          delta /= MOUSE_LINES_PER_PAGE;
        }

        return delta;
      }

      function isValidRotation(angle) {
        return Number.isInteger(angle) && angle % 90 === 0;
      }

      function isValidScrollMode(mode) {
        return Number.isInteger(mode) && Object.values(ScrollMode).includes(mode) && mode !== ScrollMode.UNKNOWN;
      }

      function isValidSpreadMode(mode) {
        return Number.isInteger(mode) && Object.values(SpreadMode).includes(mode) && mode !== SpreadMode.UNKNOWN;
      }

      function isPortraitOrientation(size) {
        return size.width <= size.height;
      }

      var WaitOnType = {
        EVENT: 'event',
        TIMEOUT: 'timeout'
      };
      exports.WaitOnType = WaitOnType;

      function waitOnEventOrTimeout(_ref2) {
        var target = _ref2.target,
            name = _ref2.name,
            _ref2$delay = _ref2.delay,
            delay = _ref2$delay === void 0 ? 0 : _ref2$delay;
        return new Promise(function (resolve, reject) {
          if (_typeof(target) !== 'object' || !(name && typeof name === 'string') || !(Number.isInteger(delay) && delay >= 0)) {
            throw new Error('waitOnEventOrTimeout - invalid parameters.');
          }

          function handler(type) {
            if (target instanceof EventBus) {
              target.off(name, eventHandler);
            } else {
              target.removeEventListener(name, eventHandler);
            }

            if (timeout) {
              clearTimeout(timeout);
            }

            resolve(type);
          }

          var eventHandler = handler.bind(null, WaitOnType.EVENT);

          if (target instanceof EventBus) {
            target.on(name, eventHandler);
          } else {
            target.addEventListener(name, eventHandler);
          }

          var timeoutHandler = handler.bind(null, WaitOnType.TIMEOUT);
          var timeout = setTimeout(timeoutHandler, delay);
        });
      }

      var animationStarted = new Promise(function (resolve) {
        window.requestAnimationFrame(resolve);
      });
      exports.animationStarted = animationStarted;

      var EventBus =
      /*#__PURE__*/
      function () {
        function EventBus() {
          var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref3$dispatchToDOM = _ref3.dispatchToDOM,
              dispatchToDOM = _ref3$dispatchToDOM === void 0 ? false : _ref3$dispatchToDOM;

          _classCallCheck(this, EventBus);

          this._listeners = Object.create(null);
          this._dispatchToDOM = dispatchToDOM === true;
        }

        _createClass(EventBus, [{
          key: "on",
          value: function on(eventName, listener) {
            var eventListeners = this._listeners[eventName];

            if (!eventListeners) {
              eventListeners = [];
              this._listeners[eventName] = eventListeners;
            }

            eventListeners.push(listener);
          }
        }, {
          key: "off",
          value: function off(eventName, listener) {
            var eventListeners = this._listeners[eventName];
            var i;

            if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
              return;
            }

            eventListeners.splice(i, 1);
          }
        }, {
          key: "dispatch",
          value: function dispatch(eventName) {
            var eventListeners = this._listeners[eventName];

            if (!eventListeners || eventListeners.length === 0) {
              if (this._dispatchToDOM) {
                var _args5 = Array.prototype.slice.call(arguments, 1);

                this._dispatchDOMEvent(eventName, _args5);
              }

              return;
            }

            var args = Array.prototype.slice.call(arguments, 1);
            eventListeners.slice(0).forEach(function (listener) {
              listener.apply(null, args);
            });

            if (this._dispatchToDOM) {
              this._dispatchDOMEvent(eventName, args);
            }
          }
        }, {
          key: "_dispatchDOMEvent",
          value: function _dispatchDOMEvent(eventName) {
            var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var details = Object.create(null);

            if (args && args.length > 0) {
              var obj = args[0];

              for (var key in obj) {
                var value = obj[key];

                if (key === 'source') {
                  if (value === window || value === document) {
                    return;
                  }

                  continue;
                }

                details[key] = value;
              }
            }

            var event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, details);
            document.dispatchEvent(event);
          }
        }]);

        return EventBus;
      }();

      exports.EventBus = EventBus;
      var globalEventBus = null;

      function getGlobalEventBus() {
        var dispatchToDOM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (!globalEventBus) {
          globalEventBus = new EventBus({
            dispatchToDOM: dispatchToDOM
          });
        }

        return globalEventBus;
      }

      function clamp(v, min, max) {
        return Math.min(Math.max(v, min), max);
      }

      var ProgressBar =
      /*#__PURE__*/
      function () {
        function ProgressBar(id) {
          var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              height = _ref4.height,
              width = _ref4.width,
              units = _ref4.units;

          _classCallCheck(this, ProgressBar);

          this.visible = true;
          this.div = document.querySelector(id + ' .progress');
          this.bar = this.div.parentNode;
          this.height = height || 100;
          this.width = width || 100;
          this.units = units || '%';
          this.div.style.height = this.height + this.units;
          this.percent = 0;
        }

        _createClass(ProgressBar, [{
          key: "_updateBar",
          value: function _updateBar() {
            if (this._indeterminate) {
              this.div.classList.add('indeterminate');
              this.div.style.width = this.width + this.units;
              return;
            }

            this.div.classList.remove('indeterminate');
            var progressSize = this.width * this._percent / 100;
            this.div.style.width = progressSize + this.units;
          }
        }, {
          key: "setWidth",
          value: function setWidth(viewer) {
            if (!viewer) {
              return;
            }

            var container = viewer.parentNode;
            var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;

            if (scrollbarWidth > 0) {
              this.bar.setAttribute('style', 'width: calc(100% - ' + scrollbarWidth + 'px);');
            }
          }
        }, {
          key: "hide",
          value: function hide() {
            if (!this.visible) {
              return;
            }

            this.visible = false;
            this.bar.classList.add('hidden');
            document.body.classList.remove('loadingInProgress');
          }
        }, {
          key: "show",
          value: function show() {
            if (this.visible) {
              return;
            }

            this.visible = true;
            document.body.classList.add('loadingInProgress');
            this.bar.classList.remove('hidden');
          }
        }, {
          key: "percent",
          get: function get() {
            return this._percent;
          },
          set: function set(val) {
            this._indeterminate = isNaN(val);
            this._percent = clamp(val, 0, 100);

            this._updateBar();
          }
        }]);

        return ProgressBar;
      }();

      exports.ProgressBar = ProgressBar;

      function moveToEndOfArray(arr, condition) {
        var moved = [],
            len = arr.length;
        var write = 0;

        for (var read = 0; read < len; ++read) {
          if (condition(arr[read])) {
            moved.push(arr[read]);
          } else {
            arr[write] = arr[read];
            ++write;
          }
        }

        for (var _read = 0; write < len; ++_read, ++write) {
          arr[write] = moved[_read];
        }
      }
      /***/

    },
    /* 4 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      module.exports = __w_pdfjs_require__(5);
      /***/
    },
    /* 5 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }

        return _typeof(obj);
      }

      var g = function () {
        return this || (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" && self;
      }() || Function("return this")();

      var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
      var oldRuntime = hadRuntime && g.regeneratorRuntime;
      g.regeneratorRuntime = undefined;
      module.exports = __w_pdfjs_require__(6);

      if (hadRuntime) {
        g.regeneratorRuntime = oldRuntime;
      } else {
        try {
          delete g.regeneratorRuntime;
        } catch (e) {
          g.regeneratorRuntime = undefined;
        }
      }
      /***/

    },
    /* 6 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (module) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
            _typeof = function _typeof(obj) {
              return _typeof2(obj);
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
            };
          }

          return _typeof(obj);
        }

        !function (global) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined;
          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
          var inModule = (false ? undefined : _typeof(module)) === "object";
          var runtime = global.regeneratorRuntime;

          if (runtime) {
            if (inModule) {
              module.exports = runtime;
            }

            return;
          }

          runtime = global.regeneratorRuntime = inModule ? module.exports : {};

          function wrap(innerFn, outerFn, self, tryLocsList) {
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []);
            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          runtime.wrap = wrap;

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed";
          var ContinueSentinel = {};

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {}

          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          runtime.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          runtime.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          };

          runtime.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  result.value = unwrapped;
                  resolve(result);
                }, function (error) {
                  return invoke("throw", error, resolve, reject);
                });
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }

            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          runtime.AsyncIterator = AsyncIterator;

          runtime.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return runtime.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                }

                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted;
                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          }

          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              context.delegate = null;

              if (context.method === "throw") {
                if (delegate.iterator["return"]) {
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              context[delegate.resultName] = info.value;
              context.next = delegate.nextLoc;

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              return info;
            }

            context.delegate = null;
            return ContinueSentinel;
          }

          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator";

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          runtime.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse();
            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              }

              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            }

            return {
              next: doneResult
            };
          }

          runtime.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0;
              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              }

              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          };
        }(function () {
          return this || (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" && self;
        }() || Function("return this")());
        /* WEBPACK VAR INJECTION */
      }).call(this, __w_pdfjs_require__(7)(module));
      /***/
    },
    /* 7 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      module.exports = function (module) {
        if (!module.webpackPolyfill) {
          module.deprecate = function () {};

          module.paths = [];
          if (!module.children) module.children = [];
          Object.defineProperty(module, "loaded", {
            enumerable: true,
            get: function get() {
              return module.l;
            }
          });
          Object.defineProperty(module, "id", {
            enumerable: true,
            get: function get() {
              return module.i;
            }
          });
          module.webpackPolyfill = 1;
        }

        return module;
      };
      /***/

    },
    /* 8 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SimpleLinkService = exports.PDFLinkService = void 0;

      var _ui_utils = __w_pdfjs_require__(3);

      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }

        return _typeof(obj);
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var PDFLinkService =
      /*#__PURE__*/
      function () {
        function PDFLinkService() {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              eventBus = _ref.eventBus,
              _ref$externalLinkTarg = _ref.externalLinkTarget,
              externalLinkTarget = _ref$externalLinkTarg === void 0 ? null : _ref$externalLinkTarg,
              _ref$externalLinkRel = _ref.externalLinkRel,
              externalLinkRel = _ref$externalLinkRel === void 0 ? null : _ref$externalLinkRel;

          _classCallCheck(this, PDFLinkService);

          this.eventBus = eventBus || (0, _ui_utils.getGlobalEventBus)();
          this.externalLinkTarget = externalLinkTarget;
          this.externalLinkRel = externalLinkRel;
          this.baseUrl = null;
          this.pdfDocument = null;
          this.pdfViewer = null;
          this.pdfHistory = null;
          this._pagesRefCache = null;
        }

        _createClass(PDFLinkService, [{
          key: "setDocument",
          value: function setDocument(pdfDocument) {
            var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            this.baseUrl = baseUrl;
            this.pdfDocument = pdfDocument;
            this._pagesRefCache = Object.create(null);
          }
        }, {
          key: "setViewer",
          value: function setViewer(pdfViewer) {
            this.pdfViewer = pdfViewer;
          }
        }, {
          key: "setHistory",
          value: function setHistory(pdfHistory) {
            this.pdfHistory = pdfHistory;
          }
        }, {
          key: "navigateTo",
          value: function navigateTo(dest) {
            var _this = this;

            var goToDestination = function goToDestination(_ref2) {
              var namedDest = _ref2.namedDest,
                  explicitDest = _ref2.explicitDest;
              var destRef = explicitDest[0],
                  pageNumber;

              if (destRef instanceof Object) {
                pageNumber = _this._cachedPageNumber(destRef);

                if (pageNumber === null) {
                  _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
                    _this.cachePageRef(pageIndex + 1, destRef);

                    goToDestination({
                      namedDest: namedDest,
                      explicitDest: explicitDest
                    });
                  })["catch"](function () {
                    console.error("PDFLinkService.navigateTo: \"".concat(destRef, "\" is not ") + "a valid page reference, for dest=\"".concat(dest, "\"."));
                  });

                  return;
                }
              } else if (Number.isInteger(destRef)) {
                pageNumber = destRef + 1;
              } else {
                console.error("PDFLinkService.navigateTo: \"".concat(destRef, "\" is not ") + "a valid destination reference, for dest=\"".concat(dest, "\"."));
                return;
              }

              if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
                console.error("PDFLinkService.navigateTo: \"".concat(pageNumber, "\" is not ") + "a valid page number, for dest=\"".concat(dest, "\"."));
                return;
              }

              if (_this.pdfHistory) {
                _this.pdfHistory.pushCurrentPosition();

                _this.pdfHistory.push({
                  namedDest: namedDest,
                  explicitDest: explicitDest,
                  pageNumber: pageNumber
                });
              }

              _this.pdfViewer.scrollPageIntoView({
                pageNumber: pageNumber,
                destArray: explicitDest
              });
            };

            new Promise(function (resolve, reject) {
              if (typeof dest === 'string') {
                _this.pdfDocument.getDestination(dest).then(function (destArray) {
                  resolve({
                    namedDest: dest,
                    explicitDest: destArray
                  });
                });

                return;
              }

              resolve({
                namedDest: '',
                explicitDest: dest
              });
            }).then(function (data) {
              if (!Array.isArray(data.explicitDest)) {
                console.error("PDFLinkService.navigateTo: \"".concat(data.explicitDest, "\" is") + " not a valid destination array, for dest=\"".concat(dest, "\"."));
                return;
              }

              goToDestination(data);
            });
          }
        }, {
          key: "getDestinationHash",
          value: function getDestinationHash(dest) {
            if (typeof dest === 'string') {
              return this.getAnchorUrl('#' + escape(dest));
            }

            if (Array.isArray(dest)) {
              var str = JSON.stringify(dest);
              return this.getAnchorUrl('#' + escape(str));
            }

            return this.getAnchorUrl('');
          }
        }, {
          key: "getAnchorUrl",
          value: function getAnchorUrl(anchor) {
            return (this.baseUrl || '') + anchor;
          }
        }, {
          key: "setHash",
          value: function setHash(hash) {
            var pageNumber, dest;

            if (hash.includes('=')) {
              var params = (0, _ui_utils.parseQueryString)(hash);

              if ('search' in params) {
                this.eventBus.dispatch('findfromurlhash', {
                  source: this,
                  query: params['search'].replace(/"/g, ''),
                  phraseSearch: params['phrase'] === 'true'
                });
              }

              if ('nameddest' in params) {
                this.navigateTo(params.nameddest);
                return;
              }

              if ('page' in params) {
                pageNumber = params.page | 0 || 1;
              }

              if ('zoom' in params) {
                var zoomArgs = params.zoom.split(',');
                var zoomArg = zoomArgs[0];
                var zoomArgNumber = parseFloat(zoomArg);

                if (!zoomArg.includes('Fit')) {
                  dest = [null, {
                    name: 'XYZ'
                  }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
                } else {
                  if (zoomArg === 'Fit' || zoomArg === 'FitB') {
                    dest = [null, {
                      name: zoomArg
                    }];
                  } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
                    dest = [null, {
                      name: zoomArg
                    }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
                  } else if (zoomArg === 'FitR') {
                    if (zoomArgs.length !== 5) {
                      console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
                    } else {
                      dest = [null, {
                        name: zoomArg
                      }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
                    }
                  } else {
                    console.error("PDFLinkService.setHash: \"".concat(zoomArg, "\" is not ") + 'a valid zoom value.');
                  }
                }
              }

              if (dest) {
                this.pdfViewer.scrollPageIntoView({
                  pageNumber: pageNumber || this.page,
                  destArray: dest,
                  allowNegativeOffset: true
                });
              } else if (pageNumber) {
                this.page = pageNumber;
              }

              if ('pagemode' in params) {
                this.eventBus.dispatch('pagemode', {
                  source: this,
                  mode: params.pagemode
                });
              }
            } else {
              dest = unescape(hash);

              try {
                dest = JSON.parse(dest);

                if (!Array.isArray(dest)) {
                  dest = dest.toString();
                }
              } catch (ex) {}

              if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
                this.navigateTo(dest);
                return;
              }

              console.error("PDFLinkService.setHash: \"".concat(unescape(hash), "\" is not ") + 'a valid destination.');
            }
          }
        }, {
          key: "executeNamedAction",
          value: function executeNamedAction(action) {
            switch (action) {
              case 'GoBack':
                if (this.pdfHistory) {
                  this.pdfHistory.back();
                }

                break;

              case 'GoForward':
                if (this.pdfHistory) {
                  this.pdfHistory.forward();
                }

                break;

              case 'NextPage':
                if (this.page < this.pagesCount) {
                  this.page++;
                }

                break;

              case 'PrevPage':
                if (this.page > 1) {
                  this.page--;
                }

                break;

              case 'LastPage':
                this.page = this.pagesCount;
                break;

              case 'FirstPage':
                this.page = 1;
                break;

              default:
                break;
            }

            this.eventBus.dispatch('namedaction', {
              source: this,
              action: action
            });
          }
        }, {
          key: "cachePageRef",
          value: function cachePageRef(pageNum, pageRef) {
            if (!pageRef) {
              return;
            }

            var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
            this._pagesRefCache[refStr] = pageNum;
          }
        }, {
          key: "_cachedPageNumber",
          value: function _cachedPageNumber(pageRef) {
            var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
            return this._pagesRefCache && this._pagesRefCache[refStr] || null;
          }
        }, {
          key: "isPageVisible",
          value: function isPageVisible(pageNumber) {
            return this.pdfViewer.isPageVisible(pageNumber);
          }
        }, {
          key: "pagesCount",
          get: function get() {
            return this.pdfDocument ? this.pdfDocument.numPages : 0;
          }
        }, {
          key: "page",
          get: function get() {
            return this.pdfViewer.currentPageNumber;
          },
          set: function set(value) {
            this.pdfViewer.currentPageNumber = value;
          }
        }, {
          key: "rotation",
          get: function get() {
            return this.pdfViewer.pagesRotation;
          },
          set: function set(value) {
            this.pdfViewer.pagesRotation = value;
          }
        }]);

        return PDFLinkService;
      }();

      exports.PDFLinkService = PDFLinkService;

      function isValidExplicitDestination(dest) {
        if (!Array.isArray(dest)) {
          return false;
        }

        var destLength = dest.length,
            allowNull = true;

        if (destLength < 2) {
          return false;
        }

        var page = dest[0];

        if (!(_typeof(page) === 'object' && Number.isInteger(page.num) && Number.isInteger(page.gen)) && !(Number.isInteger(page) && page >= 0)) {
          return false;
        }

        var zoom = dest[1];

        if (!(_typeof(zoom) === 'object' && typeof zoom.name === 'string')) {
          return false;
        }

        switch (zoom.name) {
          case 'XYZ':
            if (destLength !== 5) {
              return false;
            }

            break;

          case 'Fit':
          case 'FitB':
            return destLength === 2;

          case 'FitH':
          case 'FitBH':
          case 'FitV':
          case 'FitBV':
            if (destLength !== 3) {
              return false;
            }

            break;

          case 'FitR':
            if (destLength !== 6) {
              return false;
            }

            allowNull = false;
            break;

          default:
            return false;
        }

        for (var i = 2; i < destLength; i++) {
          var param = dest[i];

          if (!(typeof param === 'number' || allowNull && param === null)) {
            return false;
          }
        }

        return true;
      }

      var SimpleLinkService =
      /*#__PURE__*/
      function () {
        function SimpleLinkService() {
          _classCallCheck(this, SimpleLinkService);

          this.externalLinkTarget = null;
          this.externalLinkRel = null;
        }

        _createClass(SimpleLinkService, [{
          key: "navigateTo",
          value: function navigateTo(dest) {}
        }, {
          key: "getDestinationHash",
          value: function getDestinationHash(dest) {
            return '#';
          }
        }, {
          key: "getAnchorUrl",
          value: function getAnchorUrl(hash) {
            return '#';
          }
        }, {
          key: "setHash",
          value: function setHash(hash) {}
        }, {
          key: "executeNamedAction",
          value: function executeNamedAction(action) {}
        }, {
          key: "cachePageRef",
          value: function cachePageRef(pageNum, pageRef) {}
        }, {
          key: "isPageVisible",
          value: function isPageVisible(pageNumber) {
            return true;
          }
        }, {
          key: "pagesCount",
          get: function get() {
            return 0;
          }
        }, {
          key: "page",
          get: function get() {
            return 0;
          },
          set: function set(value) {}
        }, {
          key: "rotation",
          get: function get() {
            return 0;
          },
          set: function set(value) {}
        }]);

        return SimpleLinkService;
      }();

      exports.SimpleLinkService = SimpleLinkService;
      /***/
    },
    /* 9 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.DefaultTextLayerFactory = exports.TextLayerBuilder = void 0;

      var _ui_utils = __w_pdfjs_require__(3);

      var _pdfjsLib = __w_pdfjs_require__(2);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var EXPAND_DIVS_TIMEOUT = 300;

      var TextLayerBuilder =
      /*#__PURE__*/
      function () {
        function TextLayerBuilder(_ref) {
          var textLayerDiv = _ref.textLayerDiv,
              eventBus = _ref.eventBus,
              pageIndex = _ref.pageIndex,
              viewport = _ref.viewport,
              _ref$findController = _ref.findController,
              findController = _ref$findController === void 0 ? null : _ref$findController,
              _ref$enhanceTextSelec = _ref.enhanceTextSelection,
              enhanceTextSelection = _ref$enhanceTextSelec === void 0 ? false : _ref$enhanceTextSelec;

          _classCallCheck(this, TextLayerBuilder);

          this.textLayerDiv = textLayerDiv;
          this.eventBus = eventBus || (0, _ui_utils.getGlobalEventBus)();
          this.textContent = null;
          this.textContentItemsStr = [];
          this.textContentStream = null;
          this.renderingDone = false;
          this.pageIdx = pageIndex;
          this.pageNumber = this.pageIdx + 1;
          this.matches = [];
          this.viewport = viewport;
          this.textDivs = [];
          this.findController = findController;
          this.textLayerRenderTask = null;
          this.enhanceTextSelection = enhanceTextSelection;
          this._boundEvents = Object.create(null);

          this._bindEvents();

          this._bindMouse();
        }

        _createClass(TextLayerBuilder, [{
          key: "_finishRendering",
          value: function _finishRendering() {
            this.renderingDone = true;

            if (!this.enhanceTextSelection) {
              var endOfContent = document.createElement('div');
              endOfContent.className = 'endOfContent';
              this.textLayerDiv.appendChild(endOfContent);
            }

            this.eventBus.dispatch('textlayerrendered', {
              source: this,
              pageNumber: this.pageNumber,
              numTextDivs: this.textDivs.length
            });
          }
        }, {
          key: "render",
          value: function render() {
            var _this = this;

            var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!(this.textContent || this.textContentStream) || this.renderingDone) {
              return;
            }

            this.cancel();
            this.textDivs = [];
            var textLayerFrag = document.createDocumentFragment();
            this.textLayerRenderTask = (0, _pdfjsLib.renderTextLayer)({
              textContent: this.textContent,
              textContentStream: this.textContentStream,
              container: textLayerFrag,
              viewport: this.viewport,
              textDivs: this.textDivs,
              textContentItemsStr: this.textContentItemsStr,
              timeout: timeout,
              enhanceTextSelection: this.enhanceTextSelection
            });
            this.textLayerRenderTask.promise.then(function () {
              _this.textLayerDiv.appendChild(textLayerFrag);

              _this._finishRendering();

              _this._updateMatches();
            }, function (reason) {});
          }
        }, {
          key: "cancel",
          value: function cancel() {
            if (this.textLayerRenderTask) {
              this.textLayerRenderTask.cancel();
              this.textLayerRenderTask = null;
            }
          }
        }, {
          key: "setTextContentStream",
          value: function setTextContentStream(readableStream) {
            this.cancel();
            this.textContentStream = readableStream;
          }
        }, {
          key: "setTextContent",
          value: function setTextContent(textContent) {
            this.cancel();
            this.textContent = textContent;
          }
        }, {
          key: "_convertMatches",
          value: function _convertMatches(matches, matchesLength) {
            if (!matches) {
              return [];
            }

            var findController = this.findController,
                textContentItemsStr = this.textContentItemsStr;
            var i = 0,
                iIndex = 0;
            var end = textContentItemsStr.length - 1;
            var queryLen = findController.state.query.length;
            var result = [];

            for (var m = 0, mm = matches.length; m < mm; m++) {
              var matchIdx = matches[m];

              while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
                iIndex += textContentItemsStr[i].length;
                i++;
              }

              if (i === textContentItemsStr.length) {
                console.error('Could not find a matching mapping');
              }

              var match = {
                begin: {
                  divIdx: i,
                  offset: matchIdx - iIndex
                }
              };

              if (matchesLength) {
                matchIdx += matchesLength[m];
              } else {
                matchIdx += queryLen;
              }

              while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
                iIndex += textContentItemsStr[i].length;
                i++;
              }

              match.end = {
                divIdx: i,
                offset: matchIdx - iIndex
              };
              result.push(match);
            }

            return result;
          }
        }, {
          key: "_renderMatches",
          value: function _renderMatches(matches) {
            if (matches.length === 0) {
              return;
            }

            var findController = this.findController,
                pageIdx = this.pageIdx,
                textContentItemsStr = this.textContentItemsStr,
                textDivs = this.textDivs;
            var isSelectedPage = pageIdx === findController.selected.pageIdx;
            var selectedMatchIdx = findController.selected.matchIdx;
            var highlightAll = findController.state.highlightAll;
            var prevEnd = null;
            var infinity = {
              divIdx: -1,
              offset: undefined
            };

            function beginText(begin, className) {
              var divIdx = begin.divIdx;
              textDivs[divIdx].textContent = '';
              appendTextToDiv(divIdx, 0, begin.offset, className);
            }

            function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
              var div = textDivs[divIdx];
              var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
              var node = document.createTextNode(content);

              if (className) {
                var span = document.createElement('span');
                span.className = className;
                span.appendChild(node);
                div.appendChild(span);
                return;
              }

              div.appendChild(node);
            }

            var i0 = selectedMatchIdx,
                i1 = i0 + 1;

            if (highlightAll) {
              i0 = 0;
              i1 = matches.length;
            } else if (!isSelectedPage) {
              return;
            }

            for (var i = i0; i < i1; i++) {
              var match = matches[i];
              var begin = match.begin;
              var end = match.end;
              var isSelected = isSelectedPage && i === selectedMatchIdx;
              var highlightSuffix = isSelected ? ' selected' : '';

              if (isSelected) {
                findController.scrollMatchIntoView({
                  element: textDivs[begin.divIdx],
                  pageIndex: pageIdx,
                  matchIndex: selectedMatchIdx
                });
              }

              if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
                if (prevEnd !== null) {
                  appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
                }

                beginText(begin);
              } else {
                appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
              }

              if (begin.divIdx === end.divIdx) {
                appendTextToDiv(begin.divIdx, begin.offset, end.offset, 'highlight' + highlightSuffix);
              } else {
                appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, 'highlight begin' + highlightSuffix);

                for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
                  textDivs[n0].className = 'highlight middle' + highlightSuffix;
                }

                beginText(end, 'highlight end' + highlightSuffix);
              }

              prevEnd = end;
            }

            if (prevEnd) {
              appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
            }
          }
        }, {
          key: "_updateMatches",
          value: function _updateMatches() {
            if (!this.renderingDone) {
              return;
            }

            var findController = this.findController,
                matches = this.matches,
                pageIdx = this.pageIdx,
                textContentItemsStr = this.textContentItemsStr,
                textDivs = this.textDivs;
            var clearedUntilDivIdx = -1;

            for (var i = 0, ii = matches.length; i < ii; i++) {
              var match = matches[i];
              var begin = Math.max(clearedUntilDivIdx, match.begin.divIdx);

              for (var n = begin, end = match.end.divIdx; n <= end; n++) {
                var div = textDivs[n];
                div.textContent = textContentItemsStr[n];
                div.className = '';
              }

              clearedUntilDivIdx = match.end.divIdx + 1;
            }

            if (!findController || !findController.highlightMatches) {
              return;
            }

            var pageMatches = findController.pageMatches[pageIdx] || null;
            var pageMatchesLength = findController.pageMatchesLength[pageIdx] || null;
            this.matches = this._convertMatches(pageMatches, pageMatchesLength);

            this._renderMatches(this.matches);
          }
        }, {
          key: "_bindEvents",
          value: function _bindEvents() {
            var _this2 = this;

            var eventBus = this.eventBus,
                _boundEvents = this._boundEvents;

            _boundEvents.pageCancelled = function (evt) {
              if (evt.pageNumber !== _this2.pageNumber) {
                return;
              }

              if (_this2.textLayerRenderTask) {
                console.error('TextLayerBuilder._bindEvents: `this.cancel()` should ' + 'have been called when the page was reset, or rendering cancelled.');
                return;
              }

              for (var name in _boundEvents) {
                eventBus.off(name.toLowerCase(), _boundEvents[name]);
                delete _boundEvents[name];
              }
            };

            _boundEvents.updateTextLayerMatches = function (evt) {
              if (evt.pageIndex !== _this2.pageIdx && evt.pageIndex !== -1) {
                return;
              }

              _this2._updateMatches();
            };

            eventBus.on('pagecancelled', _boundEvents.pageCancelled);
            eventBus.on('updatetextlayermatches', _boundEvents.updateTextLayerMatches);
          }
        }, {
          key: "_bindMouse",
          value: function _bindMouse() {
            var _this3 = this;

            var div = this.textLayerDiv;
            var expandDivsTimer = null;
            div.addEventListener('mousedown', function (evt) {
              if (_this3.enhanceTextSelection && _this3.textLayerRenderTask) {
                _this3.textLayerRenderTask.expandTextDivs(true);

                if (expandDivsTimer) {
                  clearTimeout(expandDivsTimer);
                  expandDivsTimer = null;
                }

                return;
              }

              var end = div.querySelector('.endOfContent');

              if (!end) {
                return;
              }

              var adjustTop = evt.target !== div;
              adjustTop = adjustTop && window.getComputedStyle(end).getPropertyValue('-moz-user-select') !== 'none';

              if (adjustTop) {
                var divBounds = div.getBoundingClientRect();
                var r = Math.max(0, (evt.pageY - divBounds.top) / divBounds.height);
                end.style.top = (r * 100).toFixed(2) + '%';
              }

              end.classList.add('active');
            });
            div.addEventListener('mouseup', function () {
              if (_this3.enhanceTextSelection && _this3.textLayerRenderTask) {
                expandDivsTimer = setTimeout(function () {
                  if (_this3.textLayerRenderTask) {
                    _this3.textLayerRenderTask.expandTextDivs(false);
                  }

                  expandDivsTimer = null;
                }, EXPAND_DIVS_TIMEOUT);
                return;
              }

              var end = div.querySelector('.endOfContent');

              if (!end) {
                return;
              }

              end.style.top = '';
              end.classList.remove('active');
            });
          }
        }]);

        return TextLayerBuilder;
      }();

      exports.TextLayerBuilder = TextLayerBuilder;

      var DefaultTextLayerFactory =
      /*#__PURE__*/
      function () {
        function DefaultTextLayerFactory() {
          _classCallCheck(this, DefaultTextLayerFactory);
        }

        _createClass(DefaultTextLayerFactory, [{
          key: "createTextLayerBuilder",
          value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
            var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return new TextLayerBuilder({
              textLayerDiv: textLayerDiv,
              pageIndex: pageIndex,
              viewport: viewport,
              enhanceTextSelection: enhanceTextSelection
            });
          }
        }]);

        return DefaultTextLayerFactory;
      }();

      exports.DefaultTextLayerFactory = DefaultTextLayerFactory;
      /***/
    },
    /* 10 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.DownloadManager = void 0;

      var _pdfjsLib = __w_pdfjs_require__(2);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      ;
      var DISABLE_CREATE_OBJECT_URL = _pdfjsLib.apiCompatibilityParams.disableCreateObjectURL || false;

      function _download(blobUrl, filename) {
        var a = document.createElement('a');

        if (!a.click) {
          throw new Error('DownloadManager: "a.click()" is not supported.');
        }

        a.href = blobUrl;
        a.target = '_parent';

        if ('download' in a) {
          a.download = filename;
        }

        (document.body || document.documentElement).appendChild(a);
        a.click();
        a.remove();
      }

      var DownloadManager =
      /*#__PURE__*/
      function () {
        function DownloadManager(_ref) {
          var _ref$disableCreateObj = _ref.disableCreateObjectURL,
              disableCreateObjectURL = _ref$disableCreateObj === void 0 ? DISABLE_CREATE_OBJECT_URL : _ref$disableCreateObj;

          _classCallCheck(this, DownloadManager);

          this.disableCreateObjectURL = disableCreateObjectURL;
        }

        _createClass(DownloadManager, [{
          key: "downloadUrl",
          value: function downloadUrl(url, filename) {
            if (!(0, _pdfjsLib.createValidAbsoluteUrl)(url, 'http://example.com')) {
              return;
            }

            _download(url + '#pdfjs.action=download', filename);
          }
        }, {
          key: "downloadData",
          value: function downloadData(data, filename, contentType) {
            if (navigator.msSaveBlob) {
              return navigator.msSaveBlob(new Blob([data], {
                type: contentType
              }), filename);
            }

            var blobUrl = (0, _pdfjsLib.createObjectURL)(data, contentType, this.disableCreateObjectURL);

            _download(blobUrl, filename);
          }
        }, {
          key: "download",
          value: function download(blob, url, filename) {
            if (navigator.msSaveBlob) {
              if (!navigator.msSaveBlob(blob, filename)) {
                this.downloadUrl(url, filename);
              }

              return;
            }

            if (this.disableCreateObjectURL) {
              this.downloadUrl(url, filename);
              return;
            }

            var blobUrl = _pdfjsLib.URL.createObjectURL(blob);

            _download(blobUrl, filename);
          }
        }]);

        return DownloadManager;
      }();

      exports.DownloadManager = DownloadManager;
      /***/
    },
    /* 11 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.GenericL10n = void 0;

      var _regenerator = _interopRequireDefault(__w_pdfjs_require__(4));

      __w_pdfjs_require__(12);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      }

      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }

      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
              args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
          });
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var webL10n = document.webL10n;

      var GenericL10n =
      /*#__PURE__*/
      function () {
        function GenericL10n(lang) {
          _classCallCheck(this, GenericL10n);

          this._lang = lang;
          this._ready = new Promise(function (resolve, reject) {
            webL10n.setLanguage(lang, function () {
              resolve(webL10n);
            });
          });
        }

        _createClass(GenericL10n, [{
          key: "getLanguage",
          value: function () {
            var _getLanguage = _asyncToGenerator(
            /*#__PURE__*/
            _regenerator["default"].mark(function _callee() {
              var l10n;
              return _regenerator["default"].wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return this._ready;

                    case 2:
                      l10n = _context.sent;
                      return _context.abrupt("return", l10n.getLanguage());

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

            function getLanguage() {
              return _getLanguage.apply(this, arguments);
            }

            return getLanguage;
          }()
        }, {
          key: "getDirection",
          value: function () {
            var _getDirection = _asyncToGenerator(
            /*#__PURE__*/
            _regenerator["default"].mark(function _callee2() {
              var l10n;
              return _regenerator["default"].wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return this._ready;

                    case 2:
                      l10n = _context2.sent;
                      return _context2.abrupt("return", l10n.getDirection());

                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));

            function getDirection() {
              return _getDirection.apply(this, arguments);
            }

            return getDirection;
          }()
        }, {
          key: "get",
          value: function () {
            var _get = _asyncToGenerator(
            /*#__PURE__*/
            _regenerator["default"].mark(function _callee3(property, args, fallback) {
              var l10n;
              return _regenerator["default"].wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return this._ready;

                    case 2:
                      l10n = _context3.sent;
                      return _context3.abrupt("return", l10n.get(property, args, fallback));

                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));

            function get(_x, _x2, _x3) {
              return _get.apply(this, arguments);
            }

            return get;
          }()
        }, {
          key: "translate",
          value: function () {
            var _translate = _asyncToGenerator(
            /*#__PURE__*/
            _regenerator["default"].mark(function _callee4(element) {
              var l10n;
              return _regenerator["default"].wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return this._ready;

                    case 2:
                      l10n = _context4.sent;
                      return _context4.abrupt("return", l10n.translate(element));

                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this);
            }));

            function translate(_x4) {
              return _translate.apply(this, arguments);
            }

            return translate;
          }()
        }]);

        return GenericL10n;
      }();

      exports.GenericL10n = GenericL10n;
      /***/
    },
    /* 12 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      document.webL10n = function (window, document, undefined) {
        var gL10nData = {};
        var gTextData = '';
        var gTextProp = 'textContent';
        var gLanguage = '';
        var gMacros = {};
        var gReadyState = 'loading';
        var gAsyncResourceLoading = true;

        function getL10nResourceLinks() {
          return document.querySelectorAll('link[type="application/l10n"]');
        }

        function getL10nDictionary() {
          var script = document.querySelector('script[type="application/l10n"]');
          return script ? JSON.parse(script.innerHTML) : null;
        }

        function getTranslatableChildren(element) {
          return element ? element.querySelectorAll('*[data-l10n-id]') : [];
        }

        function getL10nAttributes(element) {
          if (!element) return {};
          var l10nId = element.getAttribute('data-l10n-id');
          var l10nArgs = element.getAttribute('data-l10n-args');
          var args = {};

          if (l10nArgs) {
            try {
              args = JSON.parse(l10nArgs);
            } catch (e) {
              console.warn('could not parse arguments for #' + l10nId);
            }
          }

          return {
            id: l10nId,
            args: args
          };
        }

        function fireL10nReadyEvent(lang) {
          var evtObject = document.createEvent('Event');
          evtObject.initEvent('localized', true, false);
          evtObject.language = lang;
          document.dispatchEvent(evtObject);
        }

        function xhrLoadText(url, onSuccess, onFailure) {
          onSuccess = onSuccess || function _onSuccess(data) {};

          onFailure = onFailure || function _onFailure() {};

          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, gAsyncResourceLoading);

          if (xhr.overrideMimeType) {
            xhr.overrideMimeType('text/plain; charset=utf-8');
          }

          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
              if (xhr.status == 200 || xhr.status === 0) {
                onSuccess(xhr.responseText);
              } else {
                onFailure();
              }
            }
          };

          xhr.onerror = onFailure;
          xhr.ontimeout = onFailure;

          try {
            xhr.send(null);
          } catch (e) {
            onFailure();
          }
        }

        function parseResource(href, lang, successCallback, failureCallback) {
          var baseURL = href.replace(/[^\/]*$/, '') || './';

          function evalString(text) {
            if (text.lastIndexOf('\\') < 0) return text;
            return text.replace(/\\\\/g, '\\').replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t').replace(/\\b/g, '\b').replace(/\\f/g, '\f').replace(/\\{/g, '{').replace(/\\}/g, '}').replace(/\\"/g, '"').replace(/\\'/g, "'");
          }

          function parseProperties(text, parsedPropertiesCallback) {
            var dictionary = {};
            var reBlank = /^\s*|\s*$/;
            var reComment = /^\s*#|^\s*$/;
            var reSection = /^\s*\[(.*)\]\s*$/;
            var reImport = /^\s*@import\s+url\((.*)\)\s*$/i;
            var reSplit = /^([^=\s]*)\s*=\s*(.+)$/;

            function parseRawLines(rawText, extendedSyntax, parsedRawLinesCallback) {
              var entries = rawText.replace(reBlank, '').split(/[\r\n]+/);
              var currentLang = '*';
              var genericLang = lang.split('-', 1)[0];
              var skipLang = false;
              var match = '';

              function nextEntry() {
                while (true) {
                  if (!entries.length) {
                    parsedRawLinesCallback();
                    return;
                  }

                  var line = entries.shift();
                  if (reComment.test(line)) continue;

                  if (extendedSyntax) {
                    match = reSection.exec(line);

                    if (match) {
                      currentLang = match[1].toLowerCase();
                      skipLang = currentLang !== '*' && currentLang !== lang && currentLang !== genericLang;
                      continue;
                    } else if (skipLang) {
                      continue;
                    }

                    match = reImport.exec(line);

                    if (match) {
                      loadImport(baseURL + match[1], nextEntry);
                      return;
                    }
                  }

                  var tmp = line.match(reSplit);

                  if (tmp && tmp.length == 3) {
                    dictionary[tmp[1]] = evalString(tmp[2]);
                  }
                }
              }

              nextEntry();
            }

            function loadImport(url, callback) {
              xhrLoadText(url, function (content) {
                parseRawLines(content, false, callback);
              }, function () {
                console.warn(url + ' not found.');
                callback();
              });
            }

            parseRawLines(text, true, function () {
              parsedPropertiesCallback(dictionary);
            });
          }

          xhrLoadText(href, function (response) {
            gTextData += response;
            parseProperties(response, function (data) {
              for (var key in data) {
                var id,
                    prop,
                    index = key.lastIndexOf('.');

                if (index > 0) {
                  id = key.substring(0, index);
                  prop = key.substring(index + 1);
                } else {
                  id = key;
                  prop = gTextProp;
                }

                if (!gL10nData[id]) {
                  gL10nData[id] = {};
                }

                gL10nData[id][prop] = data[key];
              }

              if (successCallback) {
                successCallback();
              }
            });
          }, failureCallback);
        }

        function loadLocale(lang, callback) {
          if (lang) {
            lang = lang.toLowerCase();
          }

          callback = callback || function _callback() {};

          clear();
          gLanguage = lang;
          var langLinks = getL10nResourceLinks();
          var langCount = langLinks.length;

          if (langCount === 0) {
            var dict = getL10nDictionary();

            if (dict && dict.locales && dict.default_locale) {
              console.log('using the embedded JSON directory, early way out');
              gL10nData = dict.locales[lang];

              if (!gL10nData) {
                var defaultLocale = dict.default_locale.toLowerCase();

                for (var anyCaseLang in dict.locales) {
                  anyCaseLang = anyCaseLang.toLowerCase();

                  if (anyCaseLang === lang) {
                    gL10nData = dict.locales[lang];
                    break;
                  } else if (anyCaseLang === defaultLocale) {
                    gL10nData = dict.locales[defaultLocale];
                  }
                }
              }

              callback();
            } else {
              console.log('no resource to load, early way out');
            }

            fireL10nReadyEvent(lang);
            gReadyState = 'complete';
            return;
          }

          var onResourceLoaded = null;
          var gResourceCount = 0;

          onResourceLoaded = function onResourceLoaded() {
            gResourceCount++;

            if (gResourceCount >= langCount) {
              callback();
              fireL10nReadyEvent(lang);
              gReadyState = 'complete';
            }
          };

          function L10nResourceLink(link) {
            var href = link.href;

            this.load = function (lang, callback) {
              parseResource(href, lang, callback, function () {
                console.warn(href + ' not found.');
                console.warn('"' + lang + '" resource not found');
                gLanguage = '';
                callback();
              });
            };
          }

          for (var i = 0; i < langCount; i++) {
            var resource = new L10nResourceLink(langLinks[i]);
            resource.load(lang, onResourceLoaded);
          }
        }

        function clear() {
          gL10nData = {};
          gTextData = '';
          gLanguage = '';
        }

        function getPluralRules(lang) {
          var locales2rules = {
            'af': 3,
            'ak': 4,
            'am': 4,
            'ar': 1,
            'asa': 3,
            'az': 0,
            'be': 11,
            'bem': 3,
            'bez': 3,
            'bg': 3,
            'bh': 4,
            'bm': 0,
            'bn': 3,
            'bo': 0,
            'br': 20,
            'brx': 3,
            'bs': 11,
            'ca': 3,
            'cgg': 3,
            'chr': 3,
            'cs': 12,
            'cy': 17,
            'da': 3,
            'de': 3,
            'dv': 3,
            'dz': 0,
            'ee': 3,
            'el': 3,
            'en': 3,
            'eo': 3,
            'es': 3,
            'et': 3,
            'eu': 3,
            'fa': 0,
            'ff': 5,
            'fi': 3,
            'fil': 4,
            'fo': 3,
            'fr': 5,
            'fur': 3,
            'fy': 3,
            'ga': 8,
            'gd': 24,
            'gl': 3,
            'gsw': 3,
            'gu': 3,
            'guw': 4,
            'gv': 23,
            'ha': 3,
            'haw': 3,
            'he': 2,
            'hi': 4,
            'hr': 11,
            'hu': 0,
            'id': 0,
            'ig': 0,
            'ii': 0,
            'is': 3,
            'it': 3,
            'iu': 7,
            'ja': 0,
            'jmc': 3,
            'jv': 0,
            'ka': 0,
            'kab': 5,
            'kaj': 3,
            'kcg': 3,
            'kde': 0,
            'kea': 0,
            'kk': 3,
            'kl': 3,
            'km': 0,
            'kn': 0,
            'ko': 0,
            'ksb': 3,
            'ksh': 21,
            'ku': 3,
            'kw': 7,
            'lag': 18,
            'lb': 3,
            'lg': 3,
            'ln': 4,
            'lo': 0,
            'lt': 10,
            'lv': 6,
            'mas': 3,
            'mg': 4,
            'mk': 16,
            'ml': 3,
            'mn': 3,
            'mo': 9,
            'mr': 3,
            'ms': 0,
            'mt': 15,
            'my': 0,
            'nah': 3,
            'naq': 7,
            'nb': 3,
            'nd': 3,
            'ne': 3,
            'nl': 3,
            'nn': 3,
            'no': 3,
            'nr': 3,
            'nso': 4,
            'ny': 3,
            'nyn': 3,
            'om': 3,
            'or': 3,
            'pa': 3,
            'pap': 3,
            'pl': 13,
            'ps': 3,
            'pt': 3,
            'rm': 3,
            'ro': 9,
            'rof': 3,
            'ru': 11,
            'rwk': 3,
            'sah': 0,
            'saq': 3,
            'se': 7,
            'seh': 3,
            'ses': 0,
            'sg': 0,
            'sh': 11,
            'shi': 19,
            'sk': 12,
            'sl': 14,
            'sma': 7,
            'smi': 7,
            'smj': 7,
            'smn': 7,
            'sms': 7,
            'sn': 3,
            'so': 3,
            'sq': 3,
            'sr': 11,
            'ss': 3,
            'ssy': 3,
            'st': 3,
            'sv': 3,
            'sw': 3,
            'syr': 3,
            'ta': 3,
            'te': 3,
            'teo': 3,
            'th': 0,
            'ti': 4,
            'tig': 3,
            'tk': 3,
            'tl': 4,
            'tn': 3,
            'to': 0,
            'tr': 0,
            'ts': 3,
            'tzm': 22,
            'uk': 11,
            'ur': 3,
            've': 3,
            'vi': 0,
            'vun': 3,
            'wa': 4,
            'wae': 3,
            'wo': 0,
            'xh': 3,
            'xog': 3,
            'yo': 0,
            'zh': 0,
            'zu': 3
          };

          function isIn(n, list) {
            return list.indexOf(n) !== -1;
          }

          function isBetween(n, start, end) {
            return start <= n && n <= end;
          }

          var pluralRules = {
            '0': function _(n) {
              return 'other';
            },
            '1': function _(n) {
              if (isBetween(n % 100, 3, 10)) return 'few';
              if (n === 0) return 'zero';
              if (isBetween(n % 100, 11, 99)) return 'many';
              if (n == 2) return 'two';
              if (n == 1) return 'one';
              return 'other';
            },
            '2': function _(n) {
              if (n !== 0 && n % 10 === 0) return 'many';
              if (n == 2) return 'two';
              if (n == 1) return 'one';
              return 'other';
            },
            '3': function _(n) {
              if (n == 1) return 'one';
              return 'other';
            },
            '4': function _(n) {
              if (isBetween(n, 0, 1)) return 'one';
              return 'other';
            },
            '5': function _(n) {
              if (isBetween(n, 0, 2) && n != 2) return 'one';
              return 'other';
            },
            '6': function _(n) {
              if (n === 0) return 'zero';
              if (n % 10 == 1 && n % 100 != 11) return 'one';
              return 'other';
            },
            '7': function _(n) {
              if (n == 2) return 'two';
              if (n == 1) return 'one';
              return 'other';
            },
            '8': function _(n) {
              if (isBetween(n, 3, 6)) return 'few';
              if (isBetween(n, 7, 10)) return 'many';
              if (n == 2) return 'two';
              if (n == 1) return 'one';
              return 'other';
            },
            '9': function _(n) {
              if (n === 0 || n != 1 && isBetween(n % 100, 1, 19)) return 'few';
              if (n == 1) return 'one';
              return 'other';
            },
            '10': function _(n) {
              if (isBetween(n % 10, 2, 9) && !isBetween(n % 100, 11, 19)) return 'few';
              if (n % 10 == 1 && !isBetween(n % 100, 11, 19)) return 'one';
              return 'other';
            },
            '11': function _(n) {
              if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) return 'few';
              if (n % 10 === 0 || isBetween(n % 10, 5, 9) || isBetween(n % 100, 11, 14)) return 'many';
              if (n % 10 == 1 && n % 100 != 11) return 'one';
              return 'other';
            },
            '12': function _(n) {
              if (isBetween(n, 2, 4)) return 'few';
              if (n == 1) return 'one';
              return 'other';
            },
            '13': function _(n) {
              if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) return 'few';
              if (n != 1 && isBetween(n % 10, 0, 1) || isBetween(n % 10, 5, 9) || isBetween(n % 100, 12, 14)) return 'many';
              if (n == 1) return 'one';
              return 'other';
            },
            '14': function _(n) {
              if (isBetween(n % 100, 3, 4)) return 'few';
              if (n % 100 == 2) return 'two';
              if (n % 100 == 1) return 'one';
              return 'other';
            },
            '15': function _(n) {
              if (n === 0 || isBetween(n % 100, 2, 10)) return 'few';
              if (isBetween(n % 100, 11, 19)) return 'many';
              if (n == 1) return 'one';
              return 'other';
            },
            '16': function _(n) {
              if (n % 10 == 1 && n != 11) return 'one';
              return 'other';
            },
            '17': function _(n) {
              if (n == 3) return 'few';
              if (n === 0) return 'zero';
              if (n == 6) return 'many';
              if (n == 2) return 'two';
              if (n == 1) return 'one';
              return 'other';
            },
            '18': function _(n) {
              if (n === 0) return 'zero';
              if (isBetween(n, 0, 2) && n !== 0 && n != 2) return 'one';
              return 'other';
            },
            '19': function _(n) {
              if (isBetween(n, 2, 10)) return 'few';
              if (isBetween(n, 0, 1)) return 'one';
              return 'other';
            },
            '20': function _(n) {
              if ((isBetween(n % 10, 3, 4) || n % 10 == 9) && !(isBetween(n % 100, 10, 19) || isBetween(n % 100, 70, 79) || isBetween(n % 100, 90, 99))) return 'few';
              if (n % 1000000 === 0 && n !== 0) return 'many';
              if (n % 10 == 2 && !isIn(n % 100, [12, 72, 92])) return 'two';
              if (n % 10 == 1 && !isIn(n % 100, [11, 71, 91])) return 'one';
              return 'other';
            },
            '21': function _(n) {
              if (n === 0) return 'zero';
              if (n == 1) return 'one';
              return 'other';
            },
            '22': function _(n) {
              if (isBetween(n, 0, 1) || isBetween(n, 11, 99)) return 'one';
              return 'other';
            },
            '23': function _(n) {
              if (isBetween(n % 10, 1, 2) || n % 20 === 0) return 'one';
              return 'other';
            },
            '24': function _(n) {
              if (isBetween(n, 3, 10) || isBetween(n, 13, 19)) return 'few';
              if (isIn(n, [2, 12])) return 'two';
              if (isIn(n, [1, 11])) return 'one';
              return 'other';
            }
          };
          var index = locales2rules[lang.replace(/-.*$/, '')];

          if (!(index in pluralRules)) {
            console.warn('plural form unknown for [' + lang + ']');
            return function () {
              return 'other';
            };
          }

          return pluralRules[index];
        }

        gMacros.plural = function (str, param, key, prop) {
          var n = parseFloat(param);
          if (isNaN(n)) return str;
          if (prop != gTextProp) return str;

          if (!gMacros._pluralRules) {
            gMacros._pluralRules = getPluralRules(gLanguage);
          }

          var index = '[' + gMacros._pluralRules(n) + ']';

          if (n === 0 && key + '[zero]' in gL10nData) {
            str = gL10nData[key + '[zero]'][prop];
          } else if (n == 1 && key + '[one]' in gL10nData) {
            str = gL10nData[key + '[one]'][prop];
          } else if (n == 2 && key + '[two]' in gL10nData) {
            str = gL10nData[key + '[two]'][prop];
          } else if (key + index in gL10nData) {
            str = gL10nData[key + index][prop];
          } else if (key + '[other]' in gL10nData) {
            str = gL10nData[key + '[other]'][prop];
          }

          return str;
        };

        function getL10nData(key, args, fallback) {
          var data = gL10nData[key];

          if (!data) {
            console.warn('#' + key + ' is undefined.');

            if (!fallback) {
              return null;
            }

            data = fallback;
          }

          var rv = {};

          for (var prop in data) {
            var str = data[prop];
            str = substIndexes(str, args, key, prop);
            str = substArguments(str, args, key);
            rv[prop] = str;
          }

          return rv;
        }

        function substIndexes(str, args, key, prop) {
          var reIndex = /\{\[\s*([a-zA-Z]+)\(([a-zA-Z]+)\)\s*\]\}/;
          var reMatch = reIndex.exec(str);
          if (!reMatch || !reMatch.length) return str;
          var macroName = reMatch[1];
          var paramName = reMatch[2];
          var param;

          if (args && paramName in args) {
            param = args[paramName];
          } else if (paramName in gL10nData) {
            param = gL10nData[paramName];
          }

          if (macroName in gMacros) {
            var macro = gMacros[macroName];
            str = macro(str, param, key, prop);
          }

          return str;
        }

        function substArguments(str, args, key) {
          var reArgs = /\{\{\s*(.+?)\s*\}\}/g;
          return str.replace(reArgs, function (matched_text, arg) {
            if (args && arg in args) {
              return args[arg];
            }

            if (arg in gL10nData) {
              return gL10nData[arg];
            }

            console.log('argument {{' + arg + '}} for #' + key + ' is undefined.');
            return matched_text;
          });
        }

        function translateElement(element) {
          var l10n = getL10nAttributes(element);
          if (!l10n.id) return;
          var data = getL10nData(l10n.id, l10n.args);

          if (!data) {
            console.warn('#' + l10n.id + ' is undefined.');
            return;
          }

          if (data[gTextProp]) {
            if (getChildElementCount(element) === 0) {
              element[gTextProp] = data[gTextProp];
            } else {
              var children = element.childNodes;
              var found = false;

              for (var i = 0, l = children.length; i < l; i++) {
                if (children[i].nodeType === 3 && /\S/.test(children[i].nodeValue)) {
                  if (found) {
                    children[i].nodeValue = '';
                  } else {
                    children[i].nodeValue = data[gTextProp];
                    found = true;
                  }
                }
              }

              if (!found) {
                var textNode = document.createTextNode(data[gTextProp]);
                element.insertBefore(textNode, element.firstChild);
              }
            }

            delete data[gTextProp];
          }

          for (var k in data) {
            element[k] = data[k];
          }
        }

        function getChildElementCount(element) {
          if (element.children) {
            return element.children.length;
          }

          if (typeof element.childElementCount !== 'undefined') {
            return element.childElementCount;
          }

          var count = 0;

          for (var i = 0; i < element.childNodes.length; i++) {
            count += element.nodeType === 1 ? 1 : 0;
          }

          return count;
        }

        function translateFragment(element) {
          element = element || document.documentElement;
          var children = getTranslatableChildren(element);
          var elementCount = children.length;

          for (var i = 0; i < elementCount; i++) {
            translateElement(children[i]);
          }

          translateElement(element);
        }

        return {
          get: function get(key, args, fallbackString) {
            var index = key.lastIndexOf('.');
            var prop = gTextProp;

            if (index > 0) {
              prop = key.substring(index + 1);
              key = key.substring(0, index);
            }

            var fallback;

            if (fallbackString) {
              fallback = {};
              fallback[prop] = fallbackString;
            }

            var data = getL10nData(key, args, fallback);

            if (data && prop in data) {
              return data[prop];
            }

            return '{{' + key + '}}';
          },
          getData: function getData() {
            return gL10nData;
          },
          getText: function getText() {
            return gTextData;
          },
          getLanguage: function getLanguage() {
            return gLanguage;
          },
          setLanguage: function setLanguage(lang, callback) {
            loadLocale(lang, function () {
              if (callback) callback();
            });
          },
          getDirection: function getDirection() {
            var rtlList = ['ar', 'he', 'fa', 'ps', 'ur'];
            var shortCode = gLanguage.split('-', 1)[0];
            return rtlList.indexOf(shortCode) >= 0 ? 'rtl' : 'ltr';
          },
          translate: translateFragment,
          getReadyState: function getReadyState() {
            return gReadyState;
          },
          ready: function ready(callback) {
            if (!callback) {
              return;
            } else if (gReadyState == 'complete' || gReadyState == 'interactive') {
              window.setTimeout(function () {
                callback();
              });
            } else if (document.addEventListener) {
              document.addEventListener('localized', function once() {
                document.removeEventListener('localized', once);
                callback();
              });
            }
          }
        };
      }(window, document);
      /***/

    },
    /* 13 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFFindController = exports.FindState = void 0;

      var _ui_utils = __w_pdfjs_require__(3);

      var _pdfjsLib = __w_pdfjs_require__(2);

      var _pdf_find_utils = __w_pdfjs_require__(14);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var FindState = {
        FOUND: 0,
        NOT_FOUND: 1,
        WRAPPED: 2,
        PENDING: 3
      };
      exports.FindState = FindState;
      var FIND_TIMEOUT = 250;
      var MATCH_SCROLL_OFFSET_TOP = -50;
      var MATCH_SCROLL_OFFSET_LEFT = -400;
      var CHARACTERS_TO_NORMALIZE = {
        "\u2018": '\'',
        "\u2019": '\'',
        "\u201A": '\'',
        "\u201B": '\'',
        "\u201C": '"',
        "\u201D": '"',
        "\u201E": '"',
        "\u201F": '"',
        "\xBC": '1/4',
        "\xBD": '1/2',
        "\xBE": '3/4'
      };
      var normalizationRegex = null;

      function normalize(text) {
        if (!normalizationRegex) {
          var replace = Object.keys(CHARACTERS_TO_NORMALIZE).join('');
          normalizationRegex = new RegExp("[".concat(replace, "]"), 'g');
        }

        return text.replace(normalizationRegex, function (ch) {
          return CHARACTERS_TO_NORMALIZE[ch];
        });
      }

      var PDFFindController =
      /*#__PURE__*/
      function () {
        function PDFFindController(_ref) {
          var linkService = _ref.linkService,
              _ref$eventBus = _ref.eventBus,
              eventBus = _ref$eventBus === void 0 ? (0, _ui_utils.getGlobalEventBus)() : _ref$eventBus;

          _classCallCheck(this, PDFFindController);

          this._linkService = linkService;
          this._eventBus = eventBus;

          this._reset();

          eventBus.on('findbarclose', this._onFindBarClose.bind(this));
        }

        _createClass(PDFFindController, [{
          key: "setDocument",
          value: function setDocument(pdfDocument) {
            if (this._pdfDocument) {
              this._reset();
            }

            if (!pdfDocument) {
              return;
            }

            this._pdfDocument = pdfDocument;

            this._firstPageCapability.resolve();
          }
        }, {
          key: "executeCommand",
          value: function executeCommand(cmd, state) {
            var _this = this;

            if (!state) {
              return;
            }

            var pdfDocument = this._pdfDocument;

            if (this._state === null || this._shouldDirtyMatch(cmd, state)) {
              this._dirtyMatch = true;
            }

            this._state = state;

            if (cmd !== 'findhighlightallchange') {
              this._updateUIState(FindState.PENDING);
            }

            this._firstPageCapability.promise.then(function () {
              if (!_this._pdfDocument || pdfDocument && _this._pdfDocument !== pdfDocument) {
                return;
              }

              _this._extractText();

              var findbarClosed = !_this._highlightMatches;
              var pendingTimeout = !!_this._findTimeout;

              if (_this._findTimeout) {
                clearTimeout(_this._findTimeout);
                _this._findTimeout = null;
              }

              if (cmd === 'find') {
                _this._findTimeout = setTimeout(function () {
                  _this._nextMatch();

                  _this._findTimeout = null;
                }, FIND_TIMEOUT);
              } else if (_this._dirtyMatch) {
                _this._nextMatch();
              } else if (cmd === 'findagain') {
                _this._nextMatch();

                if (findbarClosed && _this._state.highlightAll) {
                  _this._updateAllPages();
                }
              } else if (cmd === 'findhighlightallchange') {
                if (pendingTimeout) {
                  _this._nextMatch();
                } else {
                  _this._highlightMatches = true;
                }

                _this._updateAllPages();
              } else {
                _this._nextMatch();
              }
            });
          }
        }, {
          key: "scrollMatchIntoView",
          value: function scrollMatchIntoView(_ref2) {
            var _ref2$element = _ref2.element,
                element = _ref2$element === void 0 ? null : _ref2$element,
                _ref2$pageIndex = _ref2.pageIndex,
                pageIndex = _ref2$pageIndex === void 0 ? -1 : _ref2$pageIndex,
                _ref2$matchIndex = _ref2.matchIndex,
                matchIndex = _ref2$matchIndex === void 0 ? -1 : _ref2$matchIndex;

            if (!this._scrollMatches || !element) {
              return;
            } else if (matchIndex === -1 || matchIndex !== this._selected.matchIdx) {
              return;
            } else if (pageIndex === -1 || pageIndex !== this._selected.pageIdx) {
              return;
            }

            this._scrollMatches = false;
            var spot = {
              top: MATCH_SCROLL_OFFSET_TOP,
              left: MATCH_SCROLL_OFFSET_LEFT
            };
            (0, _ui_utils.scrollIntoView)(element, spot, true);
          }
        }, {
          key: "_reset",
          value: function _reset() {
            this._highlightMatches = false;
            this._scrollMatches = false;
            this._pdfDocument = null;
            this._pageMatches = [];
            this._pageMatchesLength = [];
            this._state = null;
            this._selected = {
              pageIdx: -1,
              matchIdx: -1
            };
            this._offset = {
              pageIdx: null,
              matchIdx: null,
              wrapped: false
            };
            this._extractTextPromises = [];
            this._pageContents = [];
            this._matchesCountTotal = 0;
            this._pagesToSearch = null;
            this._pendingFindMatches = Object.create(null);
            this._resumePageIdx = null;
            this._dirtyMatch = false;
            clearTimeout(this._findTimeout);
            this._findTimeout = null;
            this._firstPageCapability = (0, _pdfjsLib.createPromiseCapability)();
          }
        }, {
          key: "_shouldDirtyMatch",
          value: function _shouldDirtyMatch(cmd, state) {
            if (state.query !== this._state.query) {
              return true;
            }

            switch (cmd) {
              case 'findagain':
                var pageNumber = this._selected.pageIdx + 1;
                var linkService = this._linkService;

                if (pageNumber >= 1 && pageNumber <= linkService.pagesCount && linkService.page !== pageNumber && linkService.isPageVisible && !linkService.isPageVisible(pageNumber)) {
                  break;
                }

                return false;

              case 'findhighlightallchange':
                return false;
            }

            return true;
          }
        }, {
          key: "_prepareMatches",
          value: function _prepareMatches(matchesWithLength, matches, matchesLength) {
            function isSubTerm(matchesWithLength, currentIndex) {
              var currentElem = matchesWithLength[currentIndex];
              var nextElem = matchesWithLength[currentIndex + 1];

              if (currentIndex < matchesWithLength.length - 1 && currentElem.match === nextElem.match) {
                currentElem.skipped = true;
                return true;
              }

              for (var i = currentIndex - 1; i >= 0; i--) {
                var prevElem = matchesWithLength[i];

                if (prevElem.skipped) {
                  continue;
                }

                if (prevElem.match + prevElem.matchLength < currentElem.match) {
                  break;
                }

                if (prevElem.match + prevElem.matchLength >= currentElem.match + currentElem.matchLength) {
                  currentElem.skipped = true;
                  return true;
                }
              }

              return false;
            }

            matchesWithLength.sort(function (a, b) {
              return a.match === b.match ? a.matchLength - b.matchLength : a.match - b.match;
            });

            for (var i = 0, len = matchesWithLength.length; i < len; i++) {
              if (isSubTerm(matchesWithLength, i)) {
                continue;
              }

              matches.push(matchesWithLength[i].match);
              matchesLength.push(matchesWithLength[i].matchLength);
            }
          }
        }, {
          key: "_isEntireWord",
          value: function _isEntireWord(content, startIdx, length) {
            if (startIdx > 0) {
              var first = content.charCodeAt(startIdx);
              var limit = content.charCodeAt(startIdx - 1);

              if ((0, _pdf_find_utils.getCharacterType)(first) === (0, _pdf_find_utils.getCharacterType)(limit)) {
                return false;
              }
            }

            var endIdx = startIdx + length - 1;

            if (endIdx < content.length - 1) {
              var last = content.charCodeAt(endIdx);

              var _limit = content.charCodeAt(endIdx + 1);

              if ((0, _pdf_find_utils.getCharacterType)(last) === (0, _pdf_find_utils.getCharacterType)(_limit)) {
                return false;
              }
            }

            return true;
          }
        }, {
          key: "_calculatePhraseMatch",
          value: function _calculatePhraseMatch(query, pageIndex, pageContent, entireWord) {
            var matches = [];
            var queryLen = query.length;
            var matchIdx = -queryLen;

            while (true) {
              matchIdx = pageContent.indexOf(query, matchIdx + queryLen);

              if (matchIdx === -1) {
                break;
              }

              if (entireWord && !this._isEntireWord(pageContent, matchIdx, queryLen)) {
                continue;
              }

              matches.push(matchIdx);
            }

            this._pageMatches[pageIndex] = matches;
          }
        }, {
          key: "_calculateWordMatch",
          value: function _calculateWordMatch(query, pageIndex, pageContent, entireWord) {
            var matchesWithLength = [];
            var queryArray = query.match(/\S+/g);

            for (var i = 0, len = queryArray.length; i < len; i++) {
              var subquery = queryArray[i];
              var subqueryLen = subquery.length;
              var matchIdx = -subqueryLen;

              while (true) {
                matchIdx = pageContent.indexOf(subquery, matchIdx + subqueryLen);

                if (matchIdx === -1) {
                  break;
                }

                if (entireWord && !this._isEntireWord(pageContent, matchIdx, subqueryLen)) {
                  continue;
                }

                matchesWithLength.push({
                  match: matchIdx,
                  matchLength: subqueryLen,
                  skipped: false
                });
              }
            }

            this._pageMatchesLength[pageIndex] = [];
            this._pageMatches[pageIndex] = [];

            this._prepareMatches(matchesWithLength, this._pageMatches[pageIndex], this._pageMatchesLength[pageIndex]);
          }
        }, {
          key: "_calculateMatch",
          value: function _calculateMatch(pageIndex) {
            var pageContent = this._pageContents[pageIndex];
            var query = this._query;
            var _this$_state = this._state,
                caseSensitive = _this$_state.caseSensitive,
                entireWord = _this$_state.entireWord,
                phraseSearch = _this$_state.phraseSearch;

            if (query.length === 0) {
              return;
            }

            if (!caseSensitive) {
              pageContent = pageContent.toLowerCase();
              query = query.toLowerCase();
            }

            if (phraseSearch) {
              this._calculatePhraseMatch(query, pageIndex, pageContent, entireWord);
            } else {
              this._calculateWordMatch(query, pageIndex, pageContent, entireWord);
            }

            if (this._state.highlightAll) {
              this._updatePage(pageIndex);
            }

            if (this._resumePageIdx === pageIndex) {
              this._resumePageIdx = null;

              this._nextPageMatch();
            }

            var pageMatchesCount = this._pageMatches[pageIndex].length;

            if (pageMatchesCount > 0) {
              this._matchesCountTotal += pageMatchesCount;

              this._updateUIResultsCount();
            }
          }
        }, {
          key: "_extractText",
          value: function _extractText() {
            var _this2 = this;

            if (this._extractTextPromises.length > 0) {
              return;
            }

            var promise = Promise.resolve();

            var _loop = function _loop(i, ii) {
              var extractTextCapability = (0, _pdfjsLib.createPromiseCapability)();
              _this2._extractTextPromises[i] = extractTextCapability.promise;
              promise = promise.then(function () {
                return _this2._pdfDocument.getPage(i + 1).then(function (pdfPage) {
                  return pdfPage.getTextContent({
                    normalizeWhitespace: true
                  });
                }).then(function (textContent) {
                  var textItems = textContent.items;
                  var strBuf = [];

                  for (var j = 0, jj = textItems.length; j < jj; j++) {
                    strBuf.push(textItems[j].str);
                  }

                  _this2._pageContents[i] = normalize(strBuf.join(''));
                  extractTextCapability.resolve(i);
                }, function (reason) {
                  console.error("Unable to get text content for page ".concat(i + 1), reason);
                  _this2._pageContents[i] = '';
                  extractTextCapability.resolve(i);
                });
              });
            };

            for (var i = 0, ii = this._linkService.pagesCount; i < ii; i++) {
              _loop(i, ii);
            }
          }
        }, {
          key: "_updatePage",
          value: function _updatePage(index) {
            if (this._scrollMatches && this._selected.pageIdx === index) {
              this._linkService.page = index + 1;
            }

            this._eventBus.dispatch('updatetextlayermatches', {
              source: this,
              pageIndex: index
            });
          }
        }, {
          key: "_updateAllPages",
          value: function _updateAllPages() {
            this._eventBus.dispatch('updatetextlayermatches', {
              source: this,
              pageIndex: -1
            });
          }
        }, {
          key: "_nextMatch",
          value: function _nextMatch() {
            var _this3 = this;

            var previous = this._state.findPrevious;
            var currentPageIndex = this._linkService.page - 1;
            var numPages = this._linkService.pagesCount;
            this._highlightMatches = true;

            if (this._dirtyMatch) {
              this._dirtyMatch = false;
              this._selected.pageIdx = this._selected.matchIdx = -1;
              this._offset.pageIdx = currentPageIndex;
              this._offset.matchIdx = null;
              this._offset.wrapped = false;
              this._resumePageIdx = null;
              this._pageMatches.length = 0;
              this._pageMatchesLength.length = 0;
              this._matchesCountTotal = 0;

              this._updateAllPages();

              for (var i = 0; i < numPages; i++) {
                if (this._pendingFindMatches[i] === true) {
                  continue;
                }

                this._pendingFindMatches[i] = true;

                this._extractTextPromises[i].then(function (pageIdx) {
                  delete _this3._pendingFindMatches[pageIdx];

                  _this3._calculateMatch(pageIdx);
                });
              }
            }

            if (this._query === '') {
              this._updateUIState(FindState.FOUND);

              return;
            }

            if (this._resumePageIdx) {
              return;
            }

            var offset = this._offset;
            this._pagesToSearch = numPages;

            if (offset.matchIdx !== null) {
              var numPageMatches = this._pageMatches[offset.pageIdx].length;

              if (!previous && offset.matchIdx + 1 < numPageMatches || previous && offset.matchIdx > 0) {
                offset.matchIdx = previous ? offset.matchIdx - 1 : offset.matchIdx + 1;

                this._updateMatch(true);

                return;
              }

              this._advanceOffsetPage(previous);
            }

            this._nextPageMatch();
          }
        }, {
          key: "_matchesReady",
          value: function _matchesReady(matches) {
            var offset = this._offset;
            var numMatches = matches.length;
            var previous = this._state.findPrevious;

            if (numMatches) {
              offset.matchIdx = previous ? numMatches - 1 : 0;

              this._updateMatch(true);

              return true;
            }

            this._advanceOffsetPage(previous);

            if (offset.wrapped) {
              offset.matchIdx = null;

              if (this._pagesToSearch < 0) {
                this._updateMatch(false);

                return true;
              }
            }

            return false;
          }
        }, {
          key: "_nextPageMatch",
          value: function _nextPageMatch() {
            if (this._resumePageIdx !== null) {
              console.error('There can only be one pending page.');
            }

            var matches = null;

            do {
              var pageIdx = this._offset.pageIdx;
              matches = this._pageMatches[pageIdx];

              if (!matches) {
                this._resumePageIdx = pageIdx;
                break;
              }
            } while (!this._matchesReady(matches));
          }
        }, {
          key: "_advanceOffsetPage",
          value: function _advanceOffsetPage(previous) {
            var offset = this._offset;
            var numPages = this._linkService.pagesCount;
            offset.pageIdx = previous ? offset.pageIdx - 1 : offset.pageIdx + 1;
            offset.matchIdx = null;
            this._pagesToSearch--;

            if (offset.pageIdx >= numPages || offset.pageIdx < 0) {
              offset.pageIdx = previous ? numPages - 1 : 0;
              offset.wrapped = true;
            }
          }
        }, {
          key: "_updateMatch",
          value: function _updateMatch() {
            var found = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var state = FindState.NOT_FOUND;
            var wrapped = this._offset.wrapped;
            this._offset.wrapped = false;

            if (found) {
              var previousPage = this._selected.pageIdx;
              this._selected.pageIdx = this._offset.pageIdx;
              this._selected.matchIdx = this._offset.matchIdx;
              state = wrapped ? FindState.WRAPPED : FindState.FOUND;

              if (previousPage !== -1 && previousPage !== this._selected.pageIdx) {
                this._updatePage(previousPage);
              }
            }

            this._updateUIState(state, this._state.findPrevious);

            if (this._selected.pageIdx !== -1) {
              this._scrollMatches = true;

              this._updatePage(this._selected.pageIdx);
            }
          }
        }, {
          key: "_onFindBarClose",
          value: function _onFindBarClose(evt) {
            var _this4 = this;

            var pdfDocument = this._pdfDocument;

            this._firstPageCapability.promise.then(function () {
              if (!_this4._pdfDocument || pdfDocument && _this4._pdfDocument !== pdfDocument) {
                return;
              }

              if (_this4._findTimeout) {
                clearTimeout(_this4._findTimeout);
                _this4._findTimeout = null;
              }

              if (_this4._resumePageIdx) {
                _this4._resumePageIdx = null;
                _this4._dirtyMatch = true;
              }

              _this4._updateUIState(FindState.FOUND);

              _this4._highlightMatches = false;

              _this4._updateAllPages();
            });
          }
        }, {
          key: "_requestMatchesCount",
          value: function _requestMatchesCount() {
            var _this$_selected = this._selected,
                pageIdx = _this$_selected.pageIdx,
                matchIdx = _this$_selected.matchIdx;
            var current = 0,
                total = this._matchesCountTotal;

            if (matchIdx !== -1) {
              for (var i = 0; i < pageIdx; i++) {
                current += this._pageMatches[i] && this._pageMatches[i].length || 0;
              }

              current += matchIdx + 1;
            }

            if (current < 1 || current > total) {
              current = total = 0;
            }

            return {
              current: current,
              total: total
            };
          }
        }, {
          key: "_updateUIResultsCount",
          value: function _updateUIResultsCount() {
            this._eventBus.dispatch('updatefindmatchescount', {
              source: this,
              matchesCount: this._requestMatchesCount()
            });
          }
        }, {
          key: "_updateUIState",
          value: function _updateUIState(state, previous) {
            this._eventBus.dispatch('updatefindcontrolstate', {
              source: this,
              state: state,
              previous: previous,
              matchesCount: this._requestMatchesCount()
            });
          }
        }, {
          key: "highlightMatches",
          get: function get() {
            return this._highlightMatches;
          }
        }, {
          key: "pageMatches",
          get: function get() {
            return this._pageMatches;
          }
        }, {
          key: "pageMatchesLength",
          get: function get() {
            return this._pageMatchesLength;
          }
        }, {
          key: "selected",
          get: function get() {
            return this._selected;
          }
        }, {
          key: "state",
          get: function get() {
            return this._state;
          }
        }, {
          key: "_query",
          get: function get() {
            if (this._state.query !== this._rawQuery) {
              this._rawQuery = this._state.query;
              this._normalizedQuery = normalize(this._state.query);
            }

            return this._normalizedQuery;
          }
        }]);

        return PDFFindController;
      }();

      exports.PDFFindController = PDFFindController;
      /***/
    },
    /* 14 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getCharacterType = getCharacterType;
      exports.CharacterType = void 0;
      var CharacterType = {
        SPACE: 0,
        ALPHA_LETTER: 1,
        PUNCT: 2,
        HAN_LETTER: 3,
        KATAKANA_LETTER: 4,
        HIRAGANA_LETTER: 5,
        HALFWIDTH_KATAKANA_LETTER: 6,
        THAI_LETTER: 7
      };
      exports.CharacterType = CharacterType;

      function isAlphabeticalScript(charCode) {
        return charCode < 0x2E80;
      }

      function isAscii(charCode) {
        return (charCode & 0xFF80) === 0;
      }

      function isAsciiAlpha(charCode) {
        return charCode >= 0x61 && charCode <= 0x7A || charCode >= 0x41 && charCode <= 0x5A;
      }

      function isAsciiDigit(charCode) {
        return charCode >= 0x30 && charCode <= 0x39;
      }

      function isAsciiSpace(charCode) {
        return charCode === 0x20 || charCode === 0x09 || charCode === 0x0D || charCode === 0x0A;
      }

      function isHan(charCode) {
        return charCode >= 0x3400 && charCode <= 0x9FFF || charCode >= 0xF900 && charCode <= 0xFAFF;
      }

      function isKatakana(charCode) {
        return charCode >= 0x30A0 && charCode <= 0x30FF;
      }

      function isHiragana(charCode) {
        return charCode >= 0x3040 && charCode <= 0x309F;
      }

      function isHalfwidthKatakana(charCode) {
        return charCode >= 0xFF60 && charCode <= 0xFF9F;
      }

      function isThai(charCode) {
        return (charCode & 0xFF80) === 0x0E00;
      }

      function getCharacterType(charCode) {
        if (isAlphabeticalScript(charCode)) {
          if (isAscii(charCode)) {
            if (isAsciiSpace(charCode)) {
              return CharacterType.SPACE;
            } else if (isAsciiAlpha(charCode) || isAsciiDigit(charCode) || charCode === 0x5F) {
              return CharacterType.ALPHA_LETTER;
            }

            return CharacterType.PUNCT;
          } else if (isThai(charCode)) {
            return CharacterType.THAI_LETTER;
          } else if (charCode === 0xA0) {
            return CharacterType.SPACE;
          }

          return CharacterType.ALPHA_LETTER;
        }

        if (isHan(charCode)) {
          return CharacterType.HAN_LETTER;
        } else if (isKatakana(charCode)) {
          return CharacterType.KATAKANA_LETTER;
        } else if (isHiragana(charCode)) {
          return CharacterType.HIRAGANA_LETTER;
        } else if (isHalfwidthKatakana(charCode)) {
          return CharacterType.HALFWIDTH_KATAKANA_LETTER;
        }

        return CharacterType.ALPHA_LETTER;
      }
      /***/

    },
    /* 15 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.isDestHashesEqual = isDestHashesEqual;
      exports.isDestArraysEqual = isDestArraysEqual;
      exports.PDFHistory = void 0;

      var _ui_utils = __w_pdfjs_require__(3);

      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }

        return _typeof(obj);
      }

      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
      }

      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }

      function _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);

            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }

      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var HASH_CHANGE_TIMEOUT = 1000;
      var POSITION_UPDATED_THRESHOLD = 50;
      var UPDATE_VIEWAREA_TIMEOUT = 1000;

      function getCurrentHash() {
        return document.location.hash;
      }

      function parseCurrentHash(linkService) {
        var hash = unescape(getCurrentHash()).substring(1);
        var params = (0, _ui_utils.parseQueryString)(hash);
        var page = params.page | 0;

        if (!(Number.isInteger(page) && page > 0 && page <= linkService.pagesCount)) {
          page = null;
        }

        return {
          hash: hash,
          page: page,
          rotation: linkService.rotation
        };
      }

      var PDFHistory =
      /*#__PURE__*/
      function () {
        function PDFHistory(_ref) {
          var _this = this;

          var linkService = _ref.linkService,
              eventBus = _ref.eventBus;

          _classCallCheck(this, PDFHistory);

          this.linkService = linkService;
          this.eventBus = eventBus || (0, _ui_utils.getGlobalEventBus)();
          this.initialized = false;
          this.initialBookmark = null;
          this.initialRotation = null;
          this._boundEvents = Object.create(null);
          this._isViewerInPresentationMode = false;
          this._isPagesLoaded = false;
          this.eventBus.on('presentationmodechanged', function (evt) {
            _this._isViewerInPresentationMode = evt.active || evt.switchInProgress;
          });
          this.eventBus.on('pagesloaded', function (evt) {
            _this._isPagesLoaded = !!evt.pagesCount;
          });
        }

        _createClass(PDFHistory, [{
          key: "initialize",
          value: function initialize(_ref2) {
            var fingerprint = _ref2.fingerprint,
                _ref2$resetHistory = _ref2.resetHistory,
                resetHistory = _ref2$resetHistory === void 0 ? false : _ref2$resetHistory,
                _ref2$updateUrl = _ref2.updateUrl,
                updateUrl = _ref2$updateUrl === void 0 ? false : _ref2$updateUrl;

            if (!fingerprint || typeof fingerprint !== 'string') {
              console.error('PDFHistory.initialize: The "fingerprint" must be a non-empty string.');
              return;
            }

            var reInitialized = this.initialized && this.fingerprint !== fingerprint;
            this.fingerprint = fingerprint;
            this._updateUrl = updateUrl === true;

            if (!this.initialized) {
              this._bindEvents();
            }

            var state = window.history.state;
            this.initialized = true;
            this.initialBookmark = null;
            this.initialRotation = null;
            this._popStateInProgress = false;
            this._blockHashChange = 0;
            this._currentHash = getCurrentHash();
            this._numPositionUpdates = 0;
            this._uid = this._maxUid = 0;
            this._destination = null;
            this._position = null;

            if (!this._isValidState(state, true) || resetHistory) {
              var _parseCurrentHash = parseCurrentHash(this.linkService),
                  hash = _parseCurrentHash.hash,
                  page = _parseCurrentHash.page,
                  rotation = _parseCurrentHash.rotation;

              if (!hash || reInitialized || resetHistory) {
                this._pushOrReplaceState(null, true);

                return;
              }

              this._pushOrReplaceState({
                hash: hash,
                page: page,
                rotation: rotation
              }, true);

              return;
            }

            var destination = state.destination;

            this._updateInternalState(destination, state.uid, true);

            if (this._uid > this._maxUid) {
              this._maxUid = this._uid;
            }

            if (destination.rotation !== undefined) {
              this.initialRotation = destination.rotation;
            }

            if (destination.dest) {
              this.initialBookmark = JSON.stringify(destination.dest);
              this._destination.page = null;
            } else if (destination.hash) {
              this.initialBookmark = destination.hash;
            } else if (destination.page) {
              this.initialBookmark = "page=".concat(destination.page);
            }
          }
        }, {
          key: "push",
          value: function push(_ref3) {
            var _this2 = this;

            var _ref3$namedDest = _ref3.namedDest,
                namedDest = _ref3$namedDest === void 0 ? null : _ref3$namedDest,
                explicitDest = _ref3.explicitDest,
                pageNumber = _ref3.pageNumber;

            if (!this.initialized) {
              return;
            }

            if (namedDest && typeof namedDest !== 'string') {
              console.error('PDFHistory.push: ' + "\"".concat(namedDest, "\" is not a valid namedDest parameter."));
              return;
            } else if (!Array.isArray(explicitDest)) {
              console.error('PDFHistory.push: ' + "\"".concat(explicitDest, "\" is not a valid explicitDest parameter."));
              return;
            } else if (!(Number.isInteger(pageNumber) && pageNumber > 0 && pageNumber <= this.linkService.pagesCount)) {
              if (pageNumber !== null || this._destination) {
                console.error('PDFHistory.push: ' + "\"".concat(pageNumber, "\" is not a valid pageNumber parameter."));
                return;
              }
            }

            var hash = namedDest || JSON.stringify(explicitDest);

            if (!hash) {
              return;
            }

            var forceReplace = false;

            if (this._destination && (isDestHashesEqual(this._destination.hash, hash) || isDestArraysEqual(this._destination.dest, explicitDest))) {
              if (this._destination.page) {
                return;
              }

              forceReplace = true;
            }

            if (this._popStateInProgress && !forceReplace) {
              return;
            }

            this._pushOrReplaceState({
              dest: explicitDest,
              hash: hash,
              page: pageNumber,
              rotation: this.linkService.rotation
            }, forceReplace);

            if (!this._popStateInProgress) {
              this._popStateInProgress = true;
              Promise.resolve().then(function () {
                _this2._popStateInProgress = false;
              });
            }
          }
        }, {
          key: "pushCurrentPosition",
          value: function pushCurrentPosition() {
            if (!this.initialized || this._popStateInProgress) {
              return;
            }

            this._tryPushCurrentPosition();
          }
        }, {
          key: "back",
          value: function back() {
            if (!this.initialized || this._popStateInProgress) {
              return;
            }

            var state = window.history.state;

            if (this._isValidState(state) && state.uid > 0) {
              window.history.back();
            }
          }
        }, {
          key: "forward",
          value: function forward() {
            if (!this.initialized || this._popStateInProgress) {
              return;
            }

            var state = window.history.state;

            if (this._isValidState(state) && state.uid < this._maxUid) {
              window.history.forward();
            }
          }
        }, {
          key: "_pushOrReplaceState",
          value: function _pushOrReplaceState(destination) {
            var forceReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var shouldReplace = forceReplace || !this._destination;
            var newState = {
              fingerprint: this.fingerprint,
              uid: shouldReplace ? this._uid : this._uid + 1,
              destination: destination
            };

            this._updateInternalState(destination, newState.uid);

            var newUrl;

            if (this._updateUrl && destination && destination.hash) {
              var baseUrl = document.location.href.split('#')[0];

              if (!baseUrl.startsWith('file://')) {
                newUrl = "".concat(baseUrl, "#").concat(destination.hash);
              }
            }

            if (shouldReplace) {
              if (newUrl) {
                window.history.replaceState(newState, '', newUrl);
              } else {
                window.history.replaceState(newState, '');
              }
            } else {
              this._maxUid = this._uid;

              if (newUrl) {
                window.history.pushState(newState, '', newUrl);
              } else {
                window.history.pushState(newState, '');
              }
            }
          }
        }, {
          key: "_tryPushCurrentPosition",
          value: function _tryPushCurrentPosition() {
            var temporary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this._position) {
              return;
            }

            var position = this._position;

            if (temporary) {
              position = Object.assign(Object.create(null), this._position);
              position.temporary = true;
            }

            if (!this._destination) {
              this._pushOrReplaceState(position);

              return;
            }

            if (this._destination.temporary) {
              this._pushOrReplaceState(position, true);

              return;
            }

            if (this._destination.hash === position.hash) {
              return;
            }

            if (!this._destination.page && (POSITION_UPDATED_THRESHOLD <= 0 || this._numPositionUpdates <= POSITION_UPDATED_THRESHOLD)) {
              return;
            }

            var forceReplace = false;

            if (this._destination.page >= position.first && this._destination.page <= position.page) {
              if (this._destination.dest || !this._destination.first) {
                return;
              }

              forceReplace = true;
            }

            this._pushOrReplaceState(position, forceReplace);
          }
        }, {
          key: "_isValidState",
          value: function _isValidState(state) {
            var checkReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!state) {
              return false;
            }

            if (state.fingerprint !== this.fingerprint) {
              if (checkReload) {
                if (typeof state.fingerprint !== 'string' || state.fingerprint.length !== this.fingerprint.length) {
                  return false;
                }

                var _performance$getEntri = performance.getEntriesByType('navigation'),
                    _performance$getEntri2 = _slicedToArray(_performance$getEntri, 1),
                    perfEntry = _performance$getEntri2[0];

                if (!perfEntry || perfEntry.type !== 'reload') {
                  return false;
                }
              } else {
                return false;
              }
            }

            if (!Number.isInteger(state.uid) || state.uid < 0) {
              return false;
            }

            if (state.destination === null || _typeof(state.destination) !== 'object') {
              return false;
            }

            return true;
          }
        }, {
          key: "_updateInternalState",
          value: function _updateInternalState(destination, uid) {
            var removeTemporary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (this._updateViewareaTimeout) {
              clearTimeout(this._updateViewareaTimeout);
              this._updateViewareaTimeout = null;
            }

            if (removeTemporary && destination && destination.temporary) {
              delete destination.temporary;
            }

            this._destination = destination;
            this._uid = uid;
            this._numPositionUpdates = 0;
          }
        }, {
          key: "_updateViewarea",
          value: function _updateViewarea(_ref4) {
            var _this3 = this;

            var location = _ref4.location;

            if (this._updateViewareaTimeout) {
              clearTimeout(this._updateViewareaTimeout);
              this._updateViewareaTimeout = null;
            }

            this._position = {
              hash: this._isViewerInPresentationMode ? "page=".concat(location.pageNumber) : location.pdfOpenParams.substring(1),
              page: this.linkService.page,
              first: location.pageNumber,
              rotation: location.rotation
            };

            if (this._popStateInProgress) {
              return;
            }

            if (POSITION_UPDATED_THRESHOLD > 0 && this._isPagesLoaded && this._destination && !this._destination.page) {
              this._numPositionUpdates++;
            }

            if (UPDATE_VIEWAREA_TIMEOUT > 0) {
              this._updateViewareaTimeout = setTimeout(function () {
                if (!_this3._popStateInProgress) {
                  _this3._tryPushCurrentPosition(true);
                }

                _this3._updateViewareaTimeout = null;
              }, UPDATE_VIEWAREA_TIMEOUT);
            }
          }
        }, {
          key: "_popState",
          value: function _popState(_ref5) {
            var _this4 = this;

            var state = _ref5.state;
            var newHash = getCurrentHash(),
                hashChanged = this._currentHash !== newHash;
            this._currentHash = newHash;

            if (!state || false) {
              this._uid++;

              var _parseCurrentHash2 = parseCurrentHash(this.linkService),
                  hash = _parseCurrentHash2.hash,
                  page = _parseCurrentHash2.page,
                  rotation = _parseCurrentHash2.rotation;

              this._pushOrReplaceState({
                hash: hash,
                page: page,
                rotation: rotation
              }, true);

              return;
            }

            if (!this._isValidState(state)) {
              return;
            }

            this._popStateInProgress = true;

            if (hashChanged) {
              this._blockHashChange++;
              (0, _ui_utils.waitOnEventOrTimeout)({
                target: window,
                name: 'hashchange',
                delay: HASH_CHANGE_TIMEOUT
              }).then(function () {
                _this4._blockHashChange--;
              });
            }

            var destination = state.destination;

            this._updateInternalState(destination, state.uid, true);

            if (this._uid > this._maxUid) {
              this._maxUid = this._uid;
            }

            if ((0, _ui_utils.isValidRotation)(destination.rotation)) {
              this.linkService.rotation = destination.rotation;
            }

            if (destination.dest) {
              this.linkService.navigateTo(destination.dest);
            } else if (destination.hash) {
              this.linkService.setHash(destination.hash);
            } else if (destination.page) {
              this.linkService.page = destination.page;
            }

            Promise.resolve().then(function () {
              _this4._popStateInProgress = false;
            });
          }
        }, {
          key: "_bindEvents",
          value: function _bindEvents() {
            var _this5 = this;

            var _boundEvents = this._boundEvents,
                eventBus = this.eventBus;
            _boundEvents.updateViewarea = this._updateViewarea.bind(this);
            _boundEvents.popState = this._popState.bind(this);

            _boundEvents.pageHide = function (evt) {
              if (!_this5._destination || _this5._destination.temporary) {
                _this5._tryPushCurrentPosition();
              }
            };

            eventBus.on('updateviewarea', _boundEvents.updateViewarea);
            window.addEventListener('popstate', _boundEvents.popState);
            window.addEventListener('pagehide', _boundEvents.pageHide);
          }
        }, {
          key: "popStateInProgress",
          get: function get() {
            return this.initialized && (this._popStateInProgress || this._blockHashChange > 0);
          }
        }]);

        return PDFHistory;
      }();

      exports.PDFHistory = PDFHistory;

      function isDestHashesEqual(destHash, pushHash) {
        if (typeof destHash !== 'string' || typeof pushHash !== 'string') {
          return false;
        }

        if (destHash === pushHash) {
          return true;
        }

        var _parseQueryString = (0, _ui_utils.parseQueryString)(destHash),
            nameddest = _parseQueryString.nameddest;

        if (nameddest === pushHash) {
          return true;
        }

        return false;
      }

      function isDestArraysEqual(firstDest, secondDest) {
        function isEntryEqual(first, second) {
          if (_typeof(first) !== _typeof(second)) {
            return false;
          }

          if (Array.isArray(first) || Array.isArray(second)) {
            return false;
          }

          if (first !== null && _typeof(first) === 'object' && second !== null) {
            if (Object.keys(first).length !== Object.keys(second).length) {
              return false;
            }

            for (var key in first) {
              if (!isEntryEqual(first[key], second[key])) {
                return false;
              }
            }

            return true;
          }

          return first === second || Number.isNaN(first) && Number.isNaN(second);
        }

        if (!(Array.isArray(firstDest) && Array.isArray(secondDest))) {
          return false;
        }

        if (firstDest.length !== secondDest.length) {
          return false;
        }

        for (var i = 0, ii = firstDest.length; i < ii; i++) {
          if (!isEntryEqual(firstDest[i], secondDest[i])) {
            return false;
          }
        }

        return true;
      }
      /***/

    },
    /* 16 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFPageView = void 0;

      var _regenerator = _interopRequireDefault(__w_pdfjs_require__(4));

      var _ui_utils = __w_pdfjs_require__(3);

      var _pdfjsLib = __w_pdfjs_require__(2);

      var _pdf_rendering_queue = __w_pdfjs_require__(17);

      var _viewer_compatibility = __w_pdfjs_require__(18);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      }

      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }

      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
              args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
          });
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var MAX_CANVAS_PIXELS = _viewer_compatibility.viewerCompatibilityParams.maxCanvasPixels || 16777216;

      var PDFPageView =
      /*#__PURE__*/
      function () {
        function PDFPageView(options) {
          _classCallCheck(this, PDFPageView);

          var container = options.container;
          var defaultViewport = options.defaultViewport;
          this.id = options.id;
          this.renderingId = 'page' + this.id;
          this.pdfPage = null;
          this.pageLabel = null;
          this.rotation = 0;
          this.scale = options.scale || _ui_utils.DEFAULT_SCALE;
          this.viewport = defaultViewport;
          this.pdfPageRotate = defaultViewport.rotation;
          this.hasRestrictedScaling = false;
          this.textLayerMode = Number.isInteger(options.textLayerMode) ? options.textLayerMode : _ui_utils.TextLayerMode.ENABLE;
          this.imageResourcesPath = options.imageResourcesPath || '';
          this.renderInteractiveForms = options.renderInteractiveForms || false;
          this.useOnlyCssZoom = options.useOnlyCssZoom || false;
          this.maxCanvasPixels = options.maxCanvasPixels || MAX_CANVAS_PIXELS;
          this.eventBus = options.eventBus || (0, _ui_utils.getGlobalEventBus)();
          this.renderingQueue = options.renderingQueue;
          this.textLayerFactory = options.textLayerFactory;
          this.annotationLayerFactory = options.annotationLayerFactory;
          this.renderer = options.renderer || _ui_utils.RendererType.CANVAS;
          this.enableWebGL = options.enableWebGL || false;
          this.l10n = options.l10n || _ui_utils.NullL10n;
          this.paintTask = null;
          this.paintedViewportMap = new WeakMap();
          this.renderingState = _pdf_rendering_queue.RenderingStates.INITIAL;
          this.resume = null;
          this.error = null;
          this.onBeforeDraw = null;
          this.onAfterDraw = null;
          this.annotationLayer = null;
          this.textLayer = null;
          this.zoomLayer = null;
          var div = document.createElement('div');
          div.className = 'page';
          div.style.width = Math.floor(this.viewport.width) + 'px';
          div.style.height = Math.floor(this.viewport.height) + 'px';
          div.setAttribute('data-page-number', this.id);
          this.div = div;
          container.appendChild(div);
        }

        _createClass(PDFPageView, [{
          key: "setPdfPage",
          value: function setPdfPage(pdfPage) {
            this.pdfPage = pdfPage;
            this.pdfPageRotate = pdfPage.rotate;
            var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
            this.viewport = pdfPage.getViewport({
              scale: this.scale * _ui_utils.CSS_UNITS,
              rotation: totalRotation
            });
            this.stats = pdfPage.stats;
            this.reset();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.reset();

            if (this.pdfPage) {
              this.pdfPage.cleanup();
            }
          }
        }, {
          key: "_resetZoomLayer",
          value: function _resetZoomLayer() {
            var removeFromDOM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this.zoomLayer) {
              return;
            }

            var zoomLayerCanvas = this.zoomLayer.firstChild;
            this.paintedViewportMap["delete"](zoomLayerCanvas);
            zoomLayerCanvas.width = 0;
            zoomLayerCanvas.height = 0;

            if (removeFromDOM) {
              this.zoomLayer.remove();
            }

            this.zoomLayer = null;
          }
        }, {
          key: "reset",
          value: function reset() {
            var keepZoomLayer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var keepAnnotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            this.cancelRendering(keepAnnotations);
            var div = this.div;
            div.style.width = Math.floor(this.viewport.width) + 'px';
            div.style.height = Math.floor(this.viewport.height) + 'px';
            var childNodes = div.childNodes;
            var currentZoomLayerNode = keepZoomLayer && this.zoomLayer || null;
            var currentAnnotationNode = keepAnnotations && this.annotationLayer && this.annotationLayer.div || null;

            for (var i = childNodes.length - 1; i >= 0; i--) {
              var node = childNodes[i];

              if (currentZoomLayerNode === node || currentAnnotationNode === node) {
                continue;
              }

              div.removeChild(node);
            }

            div.removeAttribute('data-loaded');

            if (currentAnnotationNode) {
              this.annotationLayer.hide();
            } else if (this.annotationLayer) {
              this.annotationLayer.cancel();
              this.annotationLayer = null;
            }

            if (!currentZoomLayerNode) {
              if (this.canvas) {
                this.paintedViewportMap["delete"](this.canvas);
                this.canvas.width = 0;
                this.canvas.height = 0;
                delete this.canvas;
              }

              this._resetZoomLayer();
            }

            if (this.svg) {
              this.paintedViewportMap["delete"](this.svg);
              delete this.svg;
            }

            this.loadingIconDiv = document.createElement('div');
            this.loadingIconDiv.className = 'loadingIcon';
            div.appendChild(this.loadingIconDiv);
          }
        }, {
          key: "update",
          value: function update(scale, rotation) {
            this.scale = scale || this.scale;

            if (typeof rotation !== 'undefined') {
              this.rotation = rotation;
            }

            var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
            this.viewport = this.viewport.clone({
              scale: this.scale * _ui_utils.CSS_UNITS,
              rotation: totalRotation
            });

            if (this.svg) {
              this.cssTransform(this.svg, true);
              this.eventBus.dispatch('pagerendered', {
                source: this,
                pageNumber: this.id,
                cssTransform: true
              });
              return;
            }

            var isScalingRestricted = false;

            if (this.canvas && this.maxCanvasPixels > 0) {
              var outputScale = this.outputScale;

              if ((Math.floor(this.viewport.width) * outputScale.sx | 0) * (Math.floor(this.viewport.height) * outputScale.sy | 0) > this.maxCanvasPixels) {
                isScalingRestricted = true;
              }
            }

            if (this.canvas) {
              if (this.useOnlyCssZoom || this.hasRestrictedScaling && isScalingRestricted) {
                this.cssTransform(this.canvas, true);
                this.eventBus.dispatch('pagerendered', {
                  source: this,
                  pageNumber: this.id,
                  cssTransform: true
                });
                return;
              }

              if (!this.zoomLayer && !this.canvas.hasAttribute('hidden')) {
                this.zoomLayer = this.canvas.parentNode;
                this.zoomLayer.style.position = 'absolute';
              }
            }

            if (this.zoomLayer) {
              this.cssTransform(this.zoomLayer.firstChild);
            }

            this.reset(true, true);
          }
        }, {
          key: "cancelRendering",
          value: function cancelRendering() {
            var keepAnnotations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var renderingState = this.renderingState;

            if (this.paintTask) {
              this.paintTask.cancel();
              this.paintTask = null;
            }

            this.renderingState = _pdf_rendering_queue.RenderingStates.INITIAL;
            this.resume = null;

            if (this.textLayer) {
              this.textLayer.cancel();
              this.textLayer = null;
            }

            if (!keepAnnotations && this.annotationLayer) {
              this.annotationLayer.cancel();
              this.annotationLayer = null;
            }

            if (renderingState !== _pdf_rendering_queue.RenderingStates.INITIAL) {
              this.eventBus.dispatch('pagecancelled', {
                source: this,
                pageNumber: this.id,
                renderingState: renderingState
              });
            }
          }
        }, {
          key: "cssTransform",
          value: function cssTransform(target) {
            var redrawAnnotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var width = this.viewport.width;
            var height = this.viewport.height;
            var div = this.div;
            target.style.width = target.parentNode.style.width = div.style.width = Math.floor(width) + 'px';
            target.style.height = target.parentNode.style.height = div.style.height = Math.floor(height) + 'px';
            var relativeRotation = this.viewport.rotation - this.paintedViewportMap.get(target).rotation;
            var absRotation = Math.abs(relativeRotation);
            var scaleX = 1,
                scaleY = 1;

            if (absRotation === 90 || absRotation === 270) {
              scaleX = height / width;
              scaleY = width / height;
            }

            var cssTransform = 'rotate(' + relativeRotation + 'deg) ' + 'scale(' + scaleX + ',' + scaleY + ')';
            target.style.transform = cssTransform;

            if (this.textLayer) {
              var textLayerViewport = this.textLayer.viewport;
              var textRelativeRotation = this.viewport.rotation - textLayerViewport.rotation;
              var textAbsRotation = Math.abs(textRelativeRotation);
              var scale = width / textLayerViewport.width;

              if (textAbsRotation === 90 || textAbsRotation === 270) {
                scale = width / textLayerViewport.height;
              }

              var textLayerDiv = this.textLayer.textLayerDiv;
              var transX, transY;

              switch (textAbsRotation) {
                case 0:
                  transX = transY = 0;
                  break;

                case 90:
                  transX = 0;
                  transY = '-' + textLayerDiv.style.height;
                  break;

                case 180:
                  transX = '-' + textLayerDiv.style.width;
                  transY = '-' + textLayerDiv.style.height;
                  break;

                case 270:
                  transX = '-' + textLayerDiv.style.width;
                  transY = 0;
                  break;

                default:
                  console.error('Bad rotation value.');
                  break;
              }

              textLayerDiv.style.transform = 'rotate(' + textAbsRotation + 'deg) ' + 'scale(' + scale + ', ' + scale + ') ' + 'translate(' + transX + ', ' + transY + ')';
              textLayerDiv.style.transformOrigin = '0% 0%';
            }

            if (redrawAnnotations && this.annotationLayer) {
              this.annotationLayer.render(this.viewport, 'display');
            }
          }
        }, {
          key: "getPagePoint",
          value: function getPagePoint(x, y) {
            return this.viewport.convertToPdfPoint(x, y);
          }
        }, {
          key: "draw",
          value: function draw() {
            var _this = this;

            if (this.renderingState !== _pdf_rendering_queue.RenderingStates.INITIAL) {
              console.error('Must be in new state before drawing');
              this.reset();
            }

            if (!this.pdfPage) {
              this.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
              return Promise.reject(new Error('Page is not loaded'));
            }

            this.renderingState = _pdf_rendering_queue.RenderingStates.RUNNING;
            var pdfPage = this.pdfPage;
            var div = this.div;
            var canvasWrapper = document.createElement('div');
            canvasWrapper.style.width = div.style.width;
            canvasWrapper.style.height = div.style.height;
            canvasWrapper.classList.add('canvasWrapper');

            if (this.annotationLayer && this.annotationLayer.div) {
              div.insertBefore(canvasWrapper, this.annotationLayer.div);
            } else {
              div.appendChild(canvasWrapper);
            }

            var textLayer = null;

            if (this.textLayerMode !== _ui_utils.TextLayerMode.DISABLE && this.textLayerFactory) {
              var textLayerDiv = document.createElement('div');
              textLayerDiv.className = 'textLayer';
              textLayerDiv.style.width = canvasWrapper.style.width;
              textLayerDiv.style.height = canvasWrapper.style.height;

              if (this.annotationLayer && this.annotationLayer.div) {
                div.insertBefore(textLayerDiv, this.annotationLayer.div);
              } else {
                div.appendChild(textLayerDiv);
              }

              textLayer = this.textLayerFactory.createTextLayerBuilder(textLayerDiv, this.id - 1, this.viewport, this.textLayerMode === _ui_utils.TextLayerMode.ENABLE_ENHANCE);
            }

            this.textLayer = textLayer;
            var renderContinueCallback = null;

            if (this.renderingQueue) {
              renderContinueCallback = function renderContinueCallback(cont) {
                if (!_this.renderingQueue.isHighestPriority(_this)) {
                  _this.renderingState = _pdf_rendering_queue.RenderingStates.PAUSED;

                  _this.resume = function () {
                    _this.renderingState = _pdf_rendering_queue.RenderingStates.RUNNING;
                    cont();
                  };

                  return;
                }

                cont();
              };
            }

            var finishPaintTask =
            /*#__PURE__*/
            function () {
              var _ref = _asyncToGenerator(
              /*#__PURE__*/
              _regenerator["default"].mark(function _callee(error) {
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (paintTask === _this.paintTask) {
                          _this.paintTask = null;
                        }

                        if (!(error instanceof _pdfjsLib.RenderingCancelledException)) {
                          _context.next = 4;
                          break;
                        }

                        _this.error = null;
                        return _context.abrupt("return");

                      case 4:
                        _this.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;

                        if (_this.loadingIconDiv) {
                          div.removeChild(_this.loadingIconDiv);
                          delete _this.loadingIconDiv;
                        }

                        _this._resetZoomLayer(true);

                        _this.error = error;
                        _this.stats = pdfPage.stats;

                        if (_this.onAfterDraw) {
                          _this.onAfterDraw();
                        }

                        _this.eventBus.dispatch('pagerendered', {
                          source: _this,
                          pageNumber: _this.id,
                          cssTransform: false
                        });

                        if (!error) {
                          _context.next = 13;
                          break;
                        }

                        throw error;

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              return function finishPaintTask(_x) {
                return _ref.apply(this, arguments);
              };
            }();

            var paintTask = this.renderer === _ui_utils.RendererType.SVG ? this.paintOnSvg(canvasWrapper) : this.paintOnCanvas(canvasWrapper);
            paintTask.onRenderContinue = renderContinueCallback;
            this.paintTask = paintTask;
            var resultPromise = paintTask.promise.then(function () {
              return finishPaintTask(null).then(function () {
                if (textLayer) {
                  var readableStream = pdfPage.streamTextContent({
                    normalizeWhitespace: true
                  });
                  textLayer.setTextContentStream(readableStream);
                  textLayer.render();
                }
              });
            }, function (reason) {
              return finishPaintTask(reason);
            });

            if (this.annotationLayerFactory) {
              if (!this.annotationLayer) {
                this.annotationLayer = this.annotationLayerFactory.createAnnotationLayerBuilder(div, pdfPage, this.imageResourcesPath, this.renderInteractiveForms, this.l10n);
              }

              this.annotationLayer.render(this.viewport, 'display');
            }

            div.setAttribute('data-loaded', true);

            if (this.onBeforeDraw) {
              this.onBeforeDraw();
            }

            return resultPromise;
          }
        }, {
          key: "paintOnCanvas",
          value: function paintOnCanvas(canvasWrapper) {
            var renderCapability = (0, _pdfjsLib.createPromiseCapability)();
            var result = {
              promise: renderCapability.promise,
              onRenderContinue: function onRenderContinue(cont) {
                cont();
              },
              cancel: function cancel() {
                renderTask.cancel();
              }
            };
            var viewport = this.viewport;
            var canvas = document.createElement('canvas');
            canvas.id = this.renderingId;
            canvas.setAttribute('hidden', 'hidden');
            var isCanvasHidden = true;

            var showCanvas = function showCanvas() {
              if (isCanvasHidden) {
                canvas.removeAttribute('hidden');
                isCanvasHidden = false;
              }
            };

            canvasWrapper.appendChild(canvas);
            this.canvas = canvas;
            canvas.mozOpaque = true;
            var ctx = canvas.getContext('2d', {
              alpha: false
            });
            var outputScale = (0, _ui_utils.getOutputScale)(ctx);
            this.outputScale = outputScale;

            if (this.useOnlyCssZoom) {
              var actualSizeViewport = viewport.clone({
                scale: _ui_utils.CSS_UNITS
              });
              outputScale.sx *= actualSizeViewport.width / viewport.width;
              outputScale.sy *= actualSizeViewport.height / viewport.height;
              outputScale.scaled = true;
            }

            if (this.maxCanvasPixels > 0) {
              var pixelsInViewport = viewport.width * viewport.height;
              var maxScale = Math.sqrt(this.maxCanvasPixels / pixelsInViewport);

              if (outputScale.sx > maxScale || outputScale.sy > maxScale) {
                outputScale.sx = maxScale;
                outputScale.sy = maxScale;
                outputScale.scaled = true;
                this.hasRestrictedScaling = true;
              } else {
                this.hasRestrictedScaling = false;
              }
            }

            var sfx = (0, _ui_utils.approximateFraction)(outputScale.sx);
            var sfy = (0, _ui_utils.approximateFraction)(outputScale.sy);
            canvas.width = (0, _ui_utils.roundToDivide)(viewport.width * outputScale.sx, sfx[0]);
            canvas.height = (0, _ui_utils.roundToDivide)(viewport.height * outputScale.sy, sfy[0]);
            canvas.style.width = (0, _ui_utils.roundToDivide)(viewport.width, sfx[1]) + 'px';
            canvas.style.height = (0, _ui_utils.roundToDivide)(viewport.height, sfy[1]) + 'px';
            this.paintedViewportMap.set(canvas, viewport);
            var transform = !outputScale.scaled ? null : [outputScale.sx, 0, 0, outputScale.sy, 0, 0];
            var renderContext = {
              canvasContext: ctx,
              transform: transform,
              viewport: this.viewport,
              enableWebGL: this.enableWebGL,
              renderInteractiveForms: this.renderInteractiveForms
            };
            var renderTask = this.pdfPage.render(renderContext);

            renderTask.onContinue = function (cont) {
              showCanvas();

              if (result.onRenderContinue) {
                result.onRenderContinue(cont);
              } else {
                cont();
              }
            };

            renderTask.promise.then(function () {
              showCanvas();
              renderCapability.resolve(undefined);
            }, function (error) {
              showCanvas();
              renderCapability.reject(error);
            });
            return result;
          }
        }, {
          key: "paintOnSvg",
          value: function paintOnSvg(wrapper) {
            var _this2 = this;

            var cancelled = false;

            var ensureNotCancelled = function ensureNotCancelled() {
              if (cancelled) {
                throw new _pdfjsLib.RenderingCancelledException('Rendering cancelled, page ' + _this2.id, 'svg');
              }
            };

            var pdfPage = this.pdfPage;
            var actualSizeViewport = this.viewport.clone({
              scale: _ui_utils.CSS_UNITS
            });
            var promise = pdfPage.getOperatorList().then(function (opList) {
              ensureNotCancelled();
              var svgGfx = new _pdfjsLib.SVGGraphics(pdfPage.commonObjs, pdfPage.objs);
              return svgGfx.getSVG(opList, actualSizeViewport).then(function (svg) {
                ensureNotCancelled();
                _this2.svg = svg;

                _this2.paintedViewportMap.set(svg, actualSizeViewport);

                svg.style.width = wrapper.style.width;
                svg.style.height = wrapper.style.height;
                _this2.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
                wrapper.appendChild(svg);
              });
            });
            return {
              promise: promise,
              onRenderContinue: function onRenderContinue(cont) {
                cont();
              },
              cancel: function cancel() {
                cancelled = true;
              }
            };
          }
        }, {
          key: "setPageLabel",
          value: function setPageLabel(label) {
            this.pageLabel = typeof label === 'string' ? label : null;

            if (this.pageLabel !== null) {
              this.div.setAttribute('data-page-label', this.pageLabel);
            } else {
              this.div.removeAttribute('data-page-label');
            }
          }
        }, {
          key: "width",
          get: function get() {
            return this.viewport.width;
          }
        }, {
          key: "height",
          get: function get() {
            return this.viewport.height;
          }
        }]);

        return PDFPageView;
      }();

      exports.PDFPageView = PDFPageView;
      /***/
    },
    /* 17 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFRenderingQueue = exports.RenderingStates = void 0;

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var CLEANUP_TIMEOUT = 30000;
      var RenderingStates = {
        INITIAL: 0,
        RUNNING: 1,
        PAUSED: 2,
        FINISHED: 3
      };
      exports.RenderingStates = RenderingStates;

      var PDFRenderingQueue =
      /*#__PURE__*/
      function () {
        function PDFRenderingQueue() {
          _classCallCheck(this, PDFRenderingQueue);

          this.pdfViewer = null;
          this.pdfThumbnailViewer = null;
          this.onIdle = null;
          this.highestPriorityPage = null;
          this.idleTimeout = null;
          this.printing = false;
          this.isThumbnailViewEnabled = false;
        }

        _createClass(PDFRenderingQueue, [{
          key: "setViewer",
          value: function setViewer(pdfViewer) {
            this.pdfViewer = pdfViewer;
          }
        }, {
          key: "setThumbnailViewer",
          value: function setThumbnailViewer(pdfThumbnailViewer) {
            this.pdfThumbnailViewer = pdfThumbnailViewer;
          }
        }, {
          key: "isHighestPriority",
          value: function isHighestPriority(view) {
            return this.highestPriorityPage === view.renderingId;
          }
        }, {
          key: "renderHighestPriority",
          value: function renderHighestPriority(currentlyVisiblePages) {
            if (this.idleTimeout) {
              clearTimeout(this.idleTimeout);
              this.idleTimeout = null;
            }

            if (this.pdfViewer.forceRendering(currentlyVisiblePages)) {
              return;
            }

            if (this.pdfThumbnailViewer && this.isThumbnailViewEnabled) {
              if (this.pdfThumbnailViewer.forceRendering()) {
                return;
              }
            }

            if (this.printing) {
              return;
            }

            if (this.onIdle) {
              this.idleTimeout = setTimeout(this.onIdle.bind(this), CLEANUP_TIMEOUT);
            }
          }
        }, {
          key: "getHighestPriority",
          value: function getHighestPriority(visible, views, scrolledDown) {
            var visibleViews = visible.views;
            var numVisible = visibleViews.length;

            if (numVisible === 0) {
              return false;
            }

            for (var i = 0; i < numVisible; ++i) {
              var view = visibleViews[i].view;

              if (!this.isViewFinished(view)) {
                return view;
              }
            }

            if (scrolledDown) {
              var nextPageIndex = visible.last.id;

              if (views[nextPageIndex] && !this.isViewFinished(views[nextPageIndex])) {
                return views[nextPageIndex];
              }
            } else {
              var previousPageIndex = visible.first.id - 2;

              if (views[previousPageIndex] && !this.isViewFinished(views[previousPageIndex])) {
                return views[previousPageIndex];
              }
            }

            return null;
          }
        }, {
          key: "isViewFinished",
          value: function isViewFinished(view) {
            return view.renderingState === RenderingStates.FINISHED;
          }
        }, {
          key: "renderView",
          value: function renderView(view) {
            var _this = this;

            switch (view.renderingState) {
              case RenderingStates.FINISHED:
                return false;

              case RenderingStates.PAUSED:
                this.highestPriorityPage = view.renderingId;
                view.resume();
                break;

              case RenderingStates.RUNNING:
                this.highestPriorityPage = view.renderingId;
                break;

              case RenderingStates.INITIAL:
                this.highestPriorityPage = view.renderingId;

                var continueRendering = function continueRendering() {
                  _this.renderHighestPriority();
                };

                view.draw().then(continueRendering, continueRendering);
                break;
            }

            return true;
          }
        }]);

        return PDFRenderingQueue;
      }();

      exports.PDFRenderingQueue = PDFRenderingQueue;
      /***/
    },
    /* 18 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      var compatibilityParams = Object.create(null);
      {
        var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
        var isAndroid = /Android/.test(userAgent);
        var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);

        (function checkCanvasSizeLimitation() {
          if (isIOS || isAndroid) {
            compatibilityParams.maxCanvasPixels = 5242880;
          }
        })();
      }
      exports.viewerCompatibilityParams = Object.freeze(compatibilityParams);
      /***/
    },
    /* 19 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFSinglePageViewer = void 0;

      var _base_viewer = __w_pdfjs_require__(20);

      var _pdfjsLib = __w_pdfjs_require__(2);

      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }

        return _typeof(obj);
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }

        return _assertThisInitialized(self);
      }

      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
      }

      function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.get) {
          _get = Reflect.get;
        } else {
          _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);

            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);

            if (desc.get) {
              return desc.get.call(receiver);
            }

            return desc.value;
          };
        }

        return _get(target, property, receiver || target);
      }

      function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
          object = _getPrototypeOf(object);
          if (object === null) break;
        }

        return object;
      }

      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }

      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };

        return _setPrototypeOf(o, p);
      }

      var PDFSinglePageViewer =
      /*#__PURE__*/
      function (_BaseViewer) {
        _inherits(PDFSinglePageViewer, _BaseViewer);

        function PDFSinglePageViewer(options) {
          var _this;

          _classCallCheck(this, PDFSinglePageViewer);

          _this = _possibleConstructorReturn(this, _getPrototypeOf(PDFSinglePageViewer).call(this, options));

          _this.eventBus.on('pagesinit', function (evt) {
            _this._ensurePageViewVisible();
          });

          return _this;
        }

        _createClass(PDFSinglePageViewer, [{
          key: "_resetView",
          value: function _resetView() {
            _get(_getPrototypeOf(PDFSinglePageViewer.prototype), "_resetView", this).call(this);

            this._previousPageNumber = 1;
            this._shadowViewer = document.createDocumentFragment();
            this._updateScrollDown = null;
          }
        }, {
          key: "_ensurePageViewVisible",
          value: function _ensurePageViewVisible() {
            var pageView = this._pages[this._currentPageNumber - 1];
            var previousPageView = this._pages[this._previousPageNumber - 1];
            var viewerNodes = this.viewer.childNodes;

            switch (viewerNodes.length) {
              case 0:
                this.viewer.appendChild(pageView.div);
                break;

              case 1:
                if (viewerNodes[0] !== previousPageView.div) {
                  throw new Error('_ensurePageViewVisible: Unexpected previously visible page.');
                }

                if (pageView === previousPageView) {
                  break;
                }

                this._shadowViewer.appendChild(previousPageView.div);

                this.viewer.appendChild(pageView.div);
                this.container.scrollTop = 0;
                break;

              default:
                throw new Error('_ensurePageViewVisible: Only one page should be visible at a time.');
            }

            this._previousPageNumber = this._currentPageNumber;
          }
        }, {
          key: "_scrollUpdate",
          value: function _scrollUpdate() {
            if (this._updateScrollDown) {
              this._updateScrollDown();
            }

            _get(_getPrototypeOf(PDFSinglePageViewer.prototype), "_scrollUpdate", this).call(this);
          }
        }, {
          key: "_scrollIntoView",
          value: function _scrollIntoView(_ref) {
            var _this2 = this;

            var pageDiv = _ref.pageDiv,
                _ref$pageSpot = _ref.pageSpot,
                pageSpot = _ref$pageSpot === void 0 ? null : _ref$pageSpot,
                _ref$pageNumber = _ref.pageNumber,
                pageNumber = _ref$pageNumber === void 0 ? null : _ref$pageNumber;

            if (pageNumber) {
              this._setCurrentPageNumber(pageNumber);
            }

            var scrolledDown = this._currentPageNumber >= this._previousPageNumber;

            this._ensurePageViewVisible();

            this.update();

            _get(_getPrototypeOf(PDFSinglePageViewer.prototype), "_scrollIntoView", this).call(this, {
              pageDiv: pageDiv,
              pageSpot: pageSpot,
              pageNumber: pageNumber
            });

            this._updateScrollDown = function () {
              _this2.scroll.down = scrolledDown;
              _this2._updateScrollDown = null;
            };
          }
        }, {
          key: "_getVisiblePages",
          value: function _getVisiblePages() {
            return this._getCurrentVisiblePage();
          }
        }, {
          key: "_updateHelper",
          value: function _updateHelper(visiblePages) {}
        }, {
          key: "_updateScrollMode",
          value: function _updateScrollMode() {}
        }, {
          key: "_updateSpreadMode",
          value: function _updateSpreadMode() {}
        }, {
          key: "_setDocumentViewerElement",
          get: function get() {
            return (0, _pdfjsLib.shadow)(this, '_setDocumentViewerElement', this._shadowViewer);
          }
        }, {
          key: "_isScrollModeHorizontal",
          get: function get() {
            return (0, _pdfjsLib.shadow)(this, '_isScrollModeHorizontal', false);
          }
        }]);

        return PDFSinglePageViewer;
      }(_base_viewer.BaseViewer);

      exports.PDFSinglePageViewer = PDFSinglePageViewer;
      /***/
    },
    /* 20 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.BaseViewer = void 0;

      var _ui_utils = __w_pdfjs_require__(3);

      var _pdf_rendering_queue = __w_pdfjs_require__(17);

      var _annotation_layer_builder = __w_pdfjs_require__(1);

      var _pdfjsLib = __w_pdfjs_require__(2);

      var _pdf_page_view = __w_pdfjs_require__(16);

      var _pdf_link_service = __w_pdfjs_require__(8);

      var _text_layer_builder = __w_pdfjs_require__(9);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var DEFAULT_CACHE_SIZE = 10;

      function PDFPageViewBuffer(size) {
        var data = [];

        this.push = function (view) {
          var i = data.indexOf(view);

          if (i >= 0) {
            data.splice(i, 1);
          }

          data.push(view);

          if (data.length > size) {
            data.shift().destroy();
          }
        };

        this.resize = function (newSize, pagesToKeep) {
          size = newSize;

          if (pagesToKeep) {
            var pageIdsToKeep = new Set();

            for (var i = 0, iMax = pagesToKeep.length; i < iMax; ++i) {
              pageIdsToKeep.add(pagesToKeep[i].id);
            }

            (0, _ui_utils.moveToEndOfArray)(data, function (page) {
              return pageIdsToKeep.has(page.id);
            });
          }

          while (data.length > size) {
            data.shift().destroy();
          }
        };
      }

      function isSameScale(oldScale, newScale) {
        if (newScale === oldScale) {
          return true;
        }

        if (Math.abs(newScale - oldScale) < 1e-15) {
          return true;
        }

        return false;
      }

      var BaseViewer =
      /*#__PURE__*/
      function () {
        function BaseViewer(options) {
          var _this = this;

          _classCallCheck(this, BaseViewer);

          if (this.constructor === BaseViewer) {
            throw new Error('Cannot initialize BaseViewer.');
          }

          this._name = this.constructor.name;
          this.container = options.container;
          this.viewer = options.viewer || options.container.firstElementChild;
          this.eventBus = options.eventBus || (0, _ui_utils.getGlobalEventBus)();
          this.linkService = options.linkService || new _pdf_link_service.SimpleLinkService();
          this.downloadManager = options.downloadManager || null;
          this.findController = options.findController || null;
          this.removePageBorders = options.removePageBorders || false;
          this.textLayerMode = Number.isInteger(options.textLayerMode) ? options.textLayerMode : _ui_utils.TextLayerMode.ENABLE;
          this.imageResourcesPath = options.imageResourcesPath || '';
          this.renderInteractiveForms = options.renderInteractiveForms || false;
          this.enablePrintAutoRotate = options.enablePrintAutoRotate || false;
          this.renderer = options.renderer || _ui_utils.RendererType.CANVAS;
          this.enableWebGL = options.enableWebGL || false;
          this.useOnlyCssZoom = options.useOnlyCssZoom || false;
          this.maxCanvasPixels = options.maxCanvasPixels;
          this.l10n = options.l10n || _ui_utils.NullL10n;
          this.defaultRenderingQueue = !options.renderingQueue;

          if (this.defaultRenderingQueue) {
            this.renderingQueue = new _pdf_rendering_queue.PDFRenderingQueue();
            this.renderingQueue.setViewer(this);
          } else {
            this.renderingQueue = options.renderingQueue;
          }

          this.scroll = (0, _ui_utils.watchScroll)(this.container, this._scrollUpdate.bind(this));
          this.presentationModeState = _ui_utils.PresentationModeState.UNKNOWN;

          this._resetView();

          if (this.removePageBorders) {
            this.viewer.classList.add('removePageBorders');
          }

          Promise.resolve().then(function () {
            _this.eventBus.dispatch('baseviewerinit', {
              source: _this
            });
          });
        }

        _createClass(BaseViewer, [{
          key: "getPageView",
          value: function getPageView(index) {
            return this._pages[index];
          }
        }, {
          key: "_setCurrentPageNumber",
          value: function _setCurrentPageNumber(val) {
            var resetCurrentPageView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this._currentPageNumber === val) {
              if (resetCurrentPageView) {
                this._resetCurrentPageView();
              }

              return true;
            }

            if (!(0 < val && val <= this.pagesCount)) {
              return false;
            }

            this._currentPageNumber = val;
            this.eventBus.dispatch('pagechanging', {
              source: this,
              pageNumber: val,
              pageLabel: this._pageLabels && this._pageLabels[val - 1]
            });

            if (resetCurrentPageView) {
              this._resetCurrentPageView();
            }

            return true;
          }
        }, {
          key: "setDocument",
          value: function setDocument(pdfDocument) {
            var _this2 = this;

            if (this.pdfDocument) {
              this._cancelRendering();

              this._resetView();

              if (this.findController) {
                this.findController.setDocument(null);
              }
            }

            this.pdfDocument = pdfDocument;

            if (!pdfDocument) {
              return;
            }

            var pagesCount = pdfDocument.numPages;
            var pagesCapability = (0, _pdfjsLib.createPromiseCapability)();
            this.pagesPromise = pagesCapability.promise;
            pagesCapability.promise.then(function () {
              _this2._pageViewsReady = true;

              _this2.eventBus.dispatch('pagesloaded', {
                source: _this2,
                pagesCount: pagesCount
              });
            });
            var onePageRenderedCapability = (0, _pdfjsLib.createPromiseCapability)();
            this.onePageRendered = onePageRenderedCapability.promise;

            var bindOnAfterAndBeforeDraw = function bindOnAfterAndBeforeDraw(pageView) {
              pageView.onBeforeDraw = function () {
                _this2._buffer.push(pageView);
              };

              pageView.onAfterDraw = function () {
                if (!onePageRenderedCapability.settled) {
                  onePageRenderedCapability.resolve();
                }
              };
            };

            var firstPagePromise = pdfDocument.getPage(1);
            this.firstPagePromise = firstPagePromise;
            firstPagePromise.then(function (pdfPage) {
              var scale = _this2.currentScale;
              var viewport = pdfPage.getViewport({
                scale: scale * _ui_utils.CSS_UNITS
              });

              for (var pageNum = 1; pageNum <= pagesCount; ++pageNum) {
                var textLayerFactory = null;

                if (_this2.textLayerMode !== _ui_utils.TextLayerMode.DISABLE) {
                  textLayerFactory = _this2;
                }

                var pageView = new _pdf_page_view.PDFPageView({
                  container: _this2._setDocumentViewerElement,
                  eventBus: _this2.eventBus,
                  id: pageNum,
                  scale: scale,
                  defaultViewport: viewport.clone(),
                  renderingQueue: _this2.renderingQueue,
                  textLayerFactory: textLayerFactory,
                  textLayerMode: _this2.textLayerMode,
                  annotationLayerFactory: _this2,
                  imageResourcesPath: _this2.imageResourcesPath,
                  renderInteractiveForms: _this2.renderInteractiveForms,
                  renderer: _this2.renderer,
                  enableWebGL: _this2.enableWebGL,
                  useOnlyCssZoom: _this2.useOnlyCssZoom,
                  maxCanvasPixels: _this2.maxCanvasPixels,
                  l10n: _this2.l10n
                });
                bindOnAfterAndBeforeDraw(pageView);

                _this2._pages.push(pageView);
              }

              if (_this2._spreadMode !== _ui_utils.SpreadMode.NONE) {
                _this2._updateSpreadMode();
              }

              onePageRenderedCapability.promise.then(function () {
                if (pdfDocument.loadingParams['disableAutoFetch']) {
                  pagesCapability.resolve();
                  return;
                }

                var getPagesLeft = pagesCount;

                var _loop = function _loop(_pageNum) {
                  pdfDocument.getPage(_pageNum).then(function (pdfPage) {
                    var pageView = _this2._pages[_pageNum - 1];

                    if (!pageView.pdfPage) {
                      pageView.setPdfPage(pdfPage);
                    }

                    _this2.linkService.cachePageRef(_pageNum, pdfPage.ref);

                    if (--getPagesLeft === 0) {
                      pagesCapability.resolve();
                    }
                  }, function (reason) {
                    console.error("Unable to get page ".concat(_pageNum, " to initialize viewer"), reason);

                    if (--getPagesLeft === 0) {
                      pagesCapability.resolve();
                    }
                  });
                };

                for (var _pageNum = 1; _pageNum <= pagesCount; ++_pageNum) {
                  _loop(_pageNum);
                }
              });

              _this2.eventBus.dispatch('pagesinit', {
                source: _this2
              });

              if (_this2.findController) {
                _this2.findController.setDocument(pdfDocument);
              }

              if (_this2.defaultRenderingQueue) {
                _this2.update();
              }
            })["catch"](function (reason) {
              console.error('Unable to initialize viewer', reason);
            });
          }
        }, {
          key: "setPageLabels",
          value: function setPageLabels(labels) {
            if (!this.pdfDocument) {
              return;
            }

            if (!labels) {
              this._pageLabels = null;
            } else if (!(Array.isArray(labels) && this.pdfDocument.numPages === labels.length)) {
              this._pageLabels = null;
              console.error("".concat(this._name, ".setPageLabels: Invalid page labels."));
            } else {
              this._pageLabels = labels;
            }

            for (var i = 0, ii = this._pages.length; i < ii; i++) {
              var pageView = this._pages[i];
              var label = this._pageLabels && this._pageLabels[i];
              pageView.setPageLabel(label);
            }
          }
        }, {
          key: "_resetView",
          value: function _resetView() {
            this._pages = [];
            this._currentPageNumber = 1;
            this._currentScale = _ui_utils.UNKNOWN_SCALE;
            this._currentScaleValue = null;
            this._pageLabels = null;
            this._buffer = new PDFPageViewBuffer(DEFAULT_CACHE_SIZE);
            this._location = null;
            this._pagesRotation = 0;
            this._pagesRequests = [];
            this._pageViewsReady = false;
            this._scrollMode = _ui_utils.ScrollMode.VERTICAL;
            this._spreadMode = _ui_utils.SpreadMode.NONE;
            this.viewer.textContent = '';

            this._updateScrollMode();
          }
        }, {
          key: "_scrollUpdate",
          value: function _scrollUpdate() {
            if (this.pagesCount === 0) {
              return;
            }

            this.update();
          }
        }, {
          key: "_scrollIntoView",
          value: function _scrollIntoView(_ref) {
            var pageDiv = _ref.pageDiv,
                _ref$pageSpot = _ref.pageSpot,
                pageSpot = _ref$pageSpot === void 0 ? null : _ref$pageSpot,
                _ref$pageNumber = _ref.pageNumber,
                pageNumber = _ref$pageNumber === void 0 ? null : _ref$pageNumber;
            (0, _ui_utils.scrollIntoView)(pageDiv, pageSpot);
          }
        }, {
          key: "_setScaleUpdatePages",
          value: function _setScaleUpdatePages(newScale, newValue) {
            var noScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var preset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            this._currentScaleValue = newValue.toString();

            if (isSameScale(this._currentScale, newScale)) {
              if (preset) {
                this.eventBus.dispatch('scalechanging', {
                  source: this,
                  scale: newScale,
                  presetValue: newValue
                });
              }

              return;
            }

            for (var i = 0, ii = this._pages.length; i < ii; i++) {
              this._pages[i].update(newScale);
            }

            this._currentScale = newScale;

            if (!noScroll) {
              var page = this._currentPageNumber,
                  dest;

              if (this._location && !(this.isInPresentationMode || this.isChangingPresentationMode)) {
                page = this._location.pageNumber;
                dest = [null, {
                  name: 'XYZ'
                }, this._location.left, this._location.top, null];
              }

              this.scrollPageIntoView({
                pageNumber: page,
                destArray: dest,
                allowNegativeOffset: true
              });
            }

            this.eventBus.dispatch('scalechanging', {
              source: this,
              scale: newScale,
              presetValue: preset ? newValue : undefined
            });

            if (this.defaultRenderingQueue) {
              this.update();
            }
          }
        }, {
          key: "_setScale",
          value: function _setScale(value) {
            var noScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var scale = parseFloat(value);

            if (scale > 0) {
              this._setScaleUpdatePages(scale, value, noScroll, false);
            } else {
              var currentPage = this._pages[this._currentPageNumber - 1];

              if (!currentPage) {
                return;
              }

              var noPadding = this.isInPresentationMode || this.removePageBorders;
              var hPadding = noPadding ? 0 : _ui_utils.SCROLLBAR_PADDING;
              var vPadding = noPadding ? 0 : _ui_utils.VERTICAL_PADDING;

              if (!noPadding && this._isScrollModeHorizontal) {
                var _ref2 = [vPadding, hPadding];
                hPadding = _ref2[0];
                vPadding = _ref2[1];
              }

              var pageWidthScale = (this.container.clientWidth - hPadding) / currentPage.width * currentPage.scale;
              var pageHeightScale = (this.container.clientHeight - vPadding) / currentPage.height * currentPage.scale;

              switch (value) {
                case 'page-actual':
                  scale = 1;
                  break;

                case 'page-width':
                  scale = pageWidthScale;
                  break;

                case 'page-height':
                  scale = pageHeightScale;
                  break;

                case 'page-fit':
                  scale = Math.min(pageWidthScale, pageHeightScale);
                  break;

                case 'auto':
                  var horizontalScale = (0, _ui_utils.isPortraitOrientation)(currentPage) ? pageWidthScale : Math.min(pageHeightScale, pageWidthScale);
                  scale = Math.min(_ui_utils.MAX_AUTO_SCALE, horizontalScale);
                  break;

                default:
                  console.error("".concat(this._name, "._setScale: \"").concat(value, "\" is an unknown zoom value."));
                  return;
              }

              this._setScaleUpdatePages(scale, value, noScroll, true);
            }
          }
        }, {
          key: "_resetCurrentPageView",
          value: function _resetCurrentPageView() {
            if (this.isInPresentationMode) {
              this._setScale(this._currentScaleValue, true);
            }

            var pageView = this._pages[this._currentPageNumber - 1];

            this._scrollIntoView({
              pageDiv: pageView.div
            });
          }
        }, {
          key: "scrollPageIntoView",
          value: function scrollPageIntoView(_ref3) {
            var pageNumber = _ref3.pageNumber,
                _ref3$destArray = _ref3.destArray,
                destArray = _ref3$destArray === void 0 ? null : _ref3$destArray,
                _ref3$allowNegativeOf = _ref3.allowNegativeOffset,
                allowNegativeOffset = _ref3$allowNegativeOf === void 0 ? false : _ref3$allowNegativeOf;

            if (!this.pdfDocument) {
              return;
            }

            var pageView = Number.isInteger(pageNumber) && this._pages[pageNumber - 1];

            if (!pageView) {
              console.error("".concat(this._name, ".scrollPageIntoView: ") + "\"".concat(pageNumber, "\" is not a valid pageNumber parameter."));
              return;
            }

            if (this.isInPresentationMode || !destArray) {
              this._setCurrentPageNumber(pageNumber, true);

              return;
            }

            var x = 0,
                y = 0;
            var width = 0,
                height = 0,
                widthScale,
                heightScale;
            var changeOrientation = pageView.rotation % 180 === 0 ? false : true;
            var pageWidth = (changeOrientation ? pageView.height : pageView.width) / pageView.scale / _ui_utils.CSS_UNITS;
            var pageHeight = (changeOrientation ? pageView.width : pageView.height) / pageView.scale / _ui_utils.CSS_UNITS;
            var scale = 0;

            switch (destArray[1].name) {
              case 'XYZ':
                x = destArray[2];
                y = destArray[3];
                scale = destArray[4];
                x = x !== null ? x : 0;
                y = y !== null ? y : pageHeight;
                break;

              case 'Fit':
              case 'FitB':
                scale = 'page-fit';
                break;

              case 'FitH':
              case 'FitBH':
                y = destArray[2];
                scale = 'page-width';

                if (y === null && this._location) {
                  x = this._location.left;
                  y = this._location.top;
                }

                break;

              case 'FitV':
              case 'FitBV':
                x = destArray[2];
                width = pageWidth;
                height = pageHeight;
                scale = 'page-height';
                break;

              case 'FitR':
                x = destArray[2];
                y = destArray[3];
                width = destArray[4] - x;
                height = destArray[5] - y;
                var hPadding = this.removePageBorders ? 0 : _ui_utils.SCROLLBAR_PADDING;
                var vPadding = this.removePageBorders ? 0 : _ui_utils.VERTICAL_PADDING;
                widthScale = (this.container.clientWidth - hPadding) / width / _ui_utils.CSS_UNITS;
                heightScale = (this.container.clientHeight - vPadding) / height / _ui_utils.CSS_UNITS;
                scale = Math.min(Math.abs(widthScale), Math.abs(heightScale));
                break;

              default:
                console.error("".concat(this._name, ".scrollPageIntoView: ") + "\"".concat(destArray[1].name, "\" is not a valid destination type."));
                return;
            }

            if (scale && scale !== this._currentScale) {
              this.currentScaleValue = scale;
            } else if (this._currentScale === _ui_utils.UNKNOWN_SCALE) {
              this.currentScaleValue = _ui_utils.DEFAULT_SCALE_VALUE;
            }

            if (scale === 'page-fit' && !destArray[4]) {
              this._scrollIntoView({
                pageDiv: pageView.div,
                pageNumber: pageNumber
              });

              return;
            }

            var boundingRect = [pageView.viewport.convertToViewportPoint(x, y), pageView.viewport.convertToViewportPoint(x + width, y + height)];
            var left = Math.min(boundingRect[0][0], boundingRect[1][0]);
            var top = Math.min(boundingRect[0][1], boundingRect[1][1]);

            if (!allowNegativeOffset) {
              left = Math.max(left, 0);
              top = Math.max(top, 0);
            }

            this._scrollIntoView({
              pageDiv: pageView.div,
              pageSpot: {
                left: left,
                top: top
              },
              pageNumber: pageNumber
            });
          }
        }, {
          key: "_updateLocation",
          value: function _updateLocation(firstPage) {
            var currentScale = this._currentScale;
            var currentScaleValue = this._currentScaleValue;
            var normalizedScaleValue = parseFloat(currentScaleValue) === currentScale ? Math.round(currentScale * 10000) / 100 : currentScaleValue;
            var pageNumber = firstPage.id;
            var pdfOpenParams = '#page=' + pageNumber;
            pdfOpenParams += '&zoom=' + normalizedScaleValue;
            var currentPageView = this._pages[pageNumber - 1];
            var container = this.container;
            var topLeft = currentPageView.getPagePoint(container.scrollLeft - firstPage.x, container.scrollTop - firstPage.y);
            var intLeft = Math.round(topLeft[0]);
            var intTop = Math.round(topLeft[1]);
            pdfOpenParams += ',' + intLeft + ',' + intTop;
            this._location = {
              pageNumber: pageNumber,
              scale: normalizedScaleValue,
              top: intTop,
              left: intLeft,
              rotation: this._pagesRotation,
              pdfOpenParams: pdfOpenParams
            };
          }
        }, {
          key: "_updateHelper",
          value: function _updateHelper(visiblePages) {
            throw new Error('Not implemented: _updateHelper');
          }
        }, {
          key: "update",
          value: function update() {
            var visible = this._getVisiblePages();

            var visiblePages = visible.views,
                numVisiblePages = visiblePages.length;

            if (numVisiblePages === 0) {
              return;
            }

            var newCacheSize = Math.max(DEFAULT_CACHE_SIZE, 2 * numVisiblePages + 1);

            this._buffer.resize(newCacheSize, visiblePages);

            this.renderingQueue.renderHighestPriority(visible);

            this._updateHelper(visiblePages);

            this._updateLocation(visible.first);

            this.eventBus.dispatch('updateviewarea', {
              source: this,
              location: this._location
            });
          }
        }, {
          key: "containsElement",
          value: function containsElement(element) {
            return this.container.contains(element);
          }
        }, {
          key: "focus",
          value: function focus() {
            this.container.focus();
          }
        }, {
          key: "_getCurrentVisiblePage",
          value: function _getCurrentVisiblePage() {
            if (!this.pagesCount) {
              return {
                views: []
              };
            }

            var pageView = this._pages[this._currentPageNumber - 1];
            var element = pageView.div;
            var view = {
              id: pageView.id,
              x: element.offsetLeft + element.clientLeft,
              y: element.offsetTop + element.clientTop,
              view: pageView
            };
            return {
              first: view,
              last: view,
              views: [view]
            };
          }
        }, {
          key: "_getVisiblePages",
          value: function _getVisiblePages() {
            return (0, _ui_utils.getVisibleElements)(this.container, this._pages, true, this._isScrollModeHorizontal);
          }
        }, {
          key: "isPageVisible",
          value: function isPageVisible(pageNumber) {
            if (!this.pdfDocument) {
              return false;
            }

            if (this.pageNumber < 1 || pageNumber > this.pagesCount) {
              console.error("".concat(this._name, ".isPageVisible: \"").concat(pageNumber, "\" is out of bounds."));
              return false;
            }

            return this._getVisiblePages().views.some(function (view) {
              return view.id === pageNumber;
            });
          }
        }, {
          key: "cleanup",
          value: function cleanup() {
            for (var i = 0, ii = this._pages.length; i < ii; i++) {
              if (this._pages[i] && this._pages[i].renderingState !== _pdf_rendering_queue.RenderingStates.FINISHED) {
                this._pages[i].reset();
              }
            }
          }
        }, {
          key: "_cancelRendering",
          value: function _cancelRendering() {
            for (var i = 0, ii = this._pages.length; i < ii; i++) {
              if (this._pages[i]) {
                this._pages[i].cancelRendering();
              }
            }
          }
        }, {
          key: "_ensurePdfPageLoaded",
          value: function _ensurePdfPageLoaded(pageView) {
            var _this3 = this;

            if (pageView.pdfPage) {
              return Promise.resolve(pageView.pdfPage);
            }

            var pageNumber = pageView.id;

            if (this._pagesRequests[pageNumber]) {
              return this._pagesRequests[pageNumber];
            }

            var promise = this.pdfDocument.getPage(pageNumber).then(function (pdfPage) {
              if (!pageView.pdfPage) {
                pageView.setPdfPage(pdfPage);
              }

              _this3._pagesRequests[pageNumber] = null;
              return pdfPage;
            })["catch"](function (reason) {
              console.error('Unable to get page for page view', reason);
              _this3._pagesRequests[pageNumber] = null;
            });
            this._pagesRequests[pageNumber] = promise;
            return promise;
          }
        }, {
          key: "forceRendering",
          value: function forceRendering(currentlyVisiblePages) {
            var _this4 = this;

            var visiblePages = currentlyVisiblePages || this._getVisiblePages();

            var scrollAhead = this._isScrollModeHorizontal ? this.scroll.right : this.scroll.down;
            var pageView = this.renderingQueue.getHighestPriority(visiblePages, this._pages, scrollAhead);

            if (pageView) {
              this._ensurePdfPageLoaded(pageView).then(function () {
                _this4.renderingQueue.renderView(pageView);
              });

              return true;
            }

            return false;
          }
        }, {
          key: "createTextLayerBuilder",
          value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
            var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return new _text_layer_builder.TextLayerBuilder({
              textLayerDiv: textLayerDiv,
              eventBus: this.eventBus,
              pageIndex: pageIndex,
              viewport: viewport,
              findController: this.isInPresentationMode ? null : this.findController,
              enhanceTextSelection: this.isInPresentationMode ? false : enhanceTextSelection
            });
          }
        }, {
          key: "createAnnotationLayerBuilder",
          value: function createAnnotationLayerBuilder(pageDiv, pdfPage) {
            var imageResourcesPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var renderInteractiveForms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var l10n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _ui_utils.NullL10n;
            return new _annotation_layer_builder.AnnotationLayerBuilder({
              pageDiv: pageDiv,
              pdfPage: pdfPage,
              imageResourcesPath: imageResourcesPath,
              renderInteractiveForms: renderInteractiveForms,
              linkService: this.linkService,
              downloadManager: this.downloadManager,
              l10n: l10n
            });
          }
        }, {
          key: "getPagesOverview",
          value: function getPagesOverview() {
            var pagesOverview = this._pages.map(function (pageView) {
              var viewport = pageView.pdfPage.getViewport({
                scale: 1
              });
              return {
                width: viewport.width,
                height: viewport.height,
                rotation: viewport.rotation
              };
            });

            if (!this.enablePrintAutoRotate) {
              return pagesOverview;
            }

            var isFirstPagePortrait = (0, _ui_utils.isPortraitOrientation)(pagesOverview[0]);
            return pagesOverview.map(function (size) {
              if (isFirstPagePortrait === (0, _ui_utils.isPortraitOrientation)(size)) {
                return size;
              }

              return {
                width: size.height,
                height: size.width,
                rotation: (size.rotation + 90) % 360
              };
            });
          }
        }, {
          key: "_updateScrollMode",
          value: function _updateScrollMode() {
            var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var scrollMode = this._scrollMode,
                viewer = this.viewer;
            viewer.classList.toggle('scrollHorizontal', scrollMode === _ui_utils.ScrollMode.HORIZONTAL);
            viewer.classList.toggle('scrollWrapped', scrollMode === _ui_utils.ScrollMode.WRAPPED);

            if (!this.pdfDocument || !pageNumber) {
              return;
            }

            if (this._currentScaleValue && isNaN(this._currentScaleValue)) {
              this._setScale(this._currentScaleValue, true);
            }

            this._setCurrentPageNumber(pageNumber, true);

            this.update();
          }
        }, {
          key: "_updateSpreadMode",
          value: function _updateSpreadMode() {
            var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!this.pdfDocument) {
              return;
            }

            var viewer = this.viewer,
                pages = this._pages;
            viewer.textContent = '';

            if (this._spreadMode === _ui_utils.SpreadMode.NONE) {
              for (var i = 0, iMax = pages.length; i < iMax; ++i) {
                viewer.appendChild(pages[i].div);
              }
            } else {
              var parity = this._spreadMode - 1;
              var spread = null;

              for (var _i = 0, _iMax = pages.length; _i < _iMax; ++_i) {
                if (spread === null) {
                  spread = document.createElement('div');
                  spread.className = 'spread';
                  viewer.appendChild(spread);
                } else if (_i % 2 === parity) {
                  spread = spread.cloneNode(false);
                  viewer.appendChild(spread);
                }

                spread.appendChild(pages[_i].div);
              }
            }

            if (!pageNumber) {
              return;
            }

            this._setCurrentPageNumber(pageNumber, true);

            this.update();
          }
        }, {
          key: "pagesCount",
          get: function get() {
            return this._pages.length;
          }
        }, {
          key: "pageViewsReady",
          get: function get() {
            return this._pageViewsReady;
          }
        }, {
          key: "currentPageNumber",
          get: function get() {
            return this._currentPageNumber;
          },
          set: function set(val) {
            if (!Number.isInteger(val)) {
              throw new Error('Invalid page number.');
            }

            if (!this.pdfDocument) {
              return;
            }

            if (!this._setCurrentPageNumber(val, true)) {
              console.error("".concat(this._name, ".currentPageNumber: \"").concat(val, "\" is not a valid page."));
            }
          }
        }, {
          key: "currentPageLabel",
          get: function get() {
            return this._pageLabels && this._pageLabels[this._currentPageNumber - 1];
          },
          set: function set(val) {
            if (!this.pdfDocument) {
              return;
            }

            var page = val | 0;

            if (this._pageLabels) {
              var i = this._pageLabels.indexOf(val);

              if (i >= 0) {
                page = i + 1;
              }
            }

            if (!this._setCurrentPageNumber(page, true)) {
              console.error("".concat(this._name, ".currentPageLabel: \"").concat(val, "\" is not a valid page."));
            }
          }
        }, {
          key: "currentScale",
          get: function get() {
            return this._currentScale !== _ui_utils.UNKNOWN_SCALE ? this._currentScale : _ui_utils.DEFAULT_SCALE;
          },
          set: function set(val) {
            if (isNaN(val)) {
              throw new Error('Invalid numeric scale.');
            }

            if (!this.pdfDocument) {
              return;
            }

            this._setScale(val, false);
          }
        }, {
          key: "currentScaleValue",
          get: function get() {
            return this._currentScaleValue;
          },
          set: function set(val) {
            if (!this.pdfDocument) {
              return;
            }

            this._setScale(val, false);
          }
        }, {
          key: "pagesRotation",
          get: function get() {
            return this._pagesRotation;
          },
          set: function set(rotation) {
            if (!(0, _ui_utils.isValidRotation)(rotation)) {
              throw new Error('Invalid pages rotation angle.');
            }

            if (!this.pdfDocument) {
              return;
            }

            if (this._pagesRotation === rotation) {
              return;
            }

            this._pagesRotation = rotation;
            var pageNumber = this._currentPageNumber;

            for (var i = 0, ii = this._pages.length; i < ii; i++) {
              var pageView = this._pages[i];
              pageView.update(pageView.scale, rotation);
            }

            if (this._currentScaleValue) {
              this._setScale(this._currentScaleValue, true);
            }

            this.eventBus.dispatch('rotationchanging', {
              source: this,
              pagesRotation: rotation,
              pageNumber: pageNumber
            });

            if (this.defaultRenderingQueue) {
              this.update();
            }
          }
        }, {
          key: "_setDocumentViewerElement",
          get: function get() {
            throw new Error('Not implemented: _setDocumentViewerElement');
          }
        }, {
          key: "_isScrollModeHorizontal",
          get: function get() {
            return this.isInPresentationMode ? false : this._scrollMode === _ui_utils.ScrollMode.HORIZONTAL;
          }
        }, {
          key: "isInPresentationMode",
          get: function get() {
            return this.presentationModeState === _ui_utils.PresentationModeState.FULLSCREEN;
          }
        }, {
          key: "isChangingPresentationMode",
          get: function get() {
            return this.presentationModeState === _ui_utils.PresentationModeState.CHANGING;
          }
        }, {
          key: "isHorizontalScrollbarEnabled",
          get: function get() {
            return this.isInPresentationMode ? false : this.container.scrollWidth > this.container.clientWidth;
          }
        }, {
          key: "isVerticalScrollbarEnabled",
          get: function get() {
            return this.isInPresentationMode ? false : this.container.scrollHeight > this.container.clientHeight;
          }
        }, {
          key: "hasEqualPageSizes",
          get: function get() {
            var firstPageView = this._pages[0];

            for (var i = 1, ii = this._pages.length; i < ii; ++i) {
              var pageView = this._pages[i];

              if (pageView.width !== firstPageView.width || pageView.height !== firstPageView.height) {
                return false;
              }
            }

            return true;
          }
        }, {
          key: "scrollMode",
          get: function get() {
            return this._scrollMode;
          },
          set: function set(mode) {
            if (this._scrollMode === mode) {
              return;
            }

            if (!(0, _ui_utils.isValidScrollMode)(mode)) {
              throw new Error("Invalid scroll mode: ".concat(mode));
            }

            this._scrollMode = mode;
            this.eventBus.dispatch('scrollmodechanged', {
              source: this,
              mode: mode
            });

            this._updateScrollMode(this._currentPageNumber);
          }
        }, {
          key: "spreadMode",
          get: function get() {
            return this._spreadMode;
          },
          set: function set(mode) {
            if (this._spreadMode === mode) {
              return;
            }

            if (!(0, _ui_utils.isValidSpreadMode)(mode)) {
              throw new Error("Invalid spread mode: ".concat(mode));
            }

            this._spreadMode = mode;
            this.eventBus.dispatch('spreadmodechanged', {
              source: this,
              mode: mode
            });

            this._updateSpreadMode(this._currentPageNumber);
          }
        }]);

        return BaseViewer;
      }();

      exports.BaseViewer = BaseViewer;
      /***/
    },
    /* 21 */

    /***/
    function (module, exports, __w_pdfjs_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFViewer = void 0;

      var _base_viewer = __w_pdfjs_require__(20);

      var _pdfjsLib = __w_pdfjs_require__(2);

      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }

        return _typeof(obj);
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }

        return _assertThisInitialized(self);
      }

      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
      }

      function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.get) {
          _get = Reflect.get;
        } else {
          _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);

            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);

            if (desc.get) {
              return desc.get.call(receiver);
            }

            return desc.value;
          };
        }

        return _get(target, property, receiver || target);
      }

      function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
          object = _getPrototypeOf(object);
          if (object === null) break;
        }

        return object;
      }

      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }

      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };

        return _setPrototypeOf(o, p);
      }

      var PDFViewer =
      /*#__PURE__*/
      function (_BaseViewer) {
        _inherits(PDFViewer, _BaseViewer);

        function PDFViewer() {
          _classCallCheck(this, PDFViewer);

          return _possibleConstructorReturn(this, _getPrototypeOf(PDFViewer).apply(this, arguments));
        }

        _createClass(PDFViewer, [{
          key: "_scrollIntoView",
          value: function _scrollIntoView(_ref) {
            var pageDiv = _ref.pageDiv,
                _ref$pageSpot = _ref.pageSpot,
                pageSpot = _ref$pageSpot === void 0 ? null : _ref$pageSpot,
                _ref$pageNumber = _ref.pageNumber,
                pageNumber = _ref$pageNumber === void 0 ? null : _ref$pageNumber;

            if (!pageSpot && !this.isInPresentationMode) {
              var left = pageDiv.offsetLeft + pageDiv.clientLeft;
              var right = left + pageDiv.clientWidth;
              var _this$container = this.container,
                  scrollLeft = _this$container.scrollLeft,
                  clientWidth = _this$container.clientWidth;

              if (this._isScrollModeHorizontal || left < scrollLeft || right > scrollLeft + clientWidth) {
                pageSpot = {
                  left: 0,
                  top: 0
                };
              }
            }

            _get(_getPrototypeOf(PDFViewer.prototype), "_scrollIntoView", this).call(this, {
              pageDiv: pageDiv,
              pageSpot: pageSpot,
              pageNumber: pageNumber
            });
          }
        }, {
          key: "_getVisiblePages",
          value: function _getVisiblePages() {
            if (this.isInPresentationMode) {
              return this._getCurrentVisiblePage();
            }

            return _get(_getPrototypeOf(PDFViewer.prototype), "_getVisiblePages", this).call(this);
          }
        }, {
          key: "_updateHelper",
          value: function _updateHelper(visiblePages) {
            if (this.isInPresentationMode) {
              return;
            }

            var currentId = this._currentPageNumber;
            var stillFullyVisible = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = visiblePages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var page = _step.value;

                if (page.percent < 100) {
                  break;
                }

                if (page.id === currentId) {
                  stillFullyVisible = true;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (!stillFullyVisible) {
              currentId = visiblePages[0].id;
            }

            this._setCurrentPageNumber(currentId);
          }
        }, {
          key: "_setDocumentViewerElement",
          get: function get() {
            return (0, _pdfjsLib.shadow)(this, '_setDocumentViewerElement', this.viewer);
          }
        }]);

        return PDFViewer;
      }(_base_viewer.BaseViewer);

      exports.PDFViewer = PDFViewer;
      /***/
    }])
  );
});